export default {
  date: {
    formats: {
      default: '%d/%m/%Y',
      short: '%e %B',
      long: '%-d %B %Y',
      with_day: '%A %-d %B',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'zondag',
      'maandag',
      'dinsdag',
      'woensdag',
      'donderdag',
      'vrijdag',
      'zaterdag',
    ],
    abbr_day_names: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
    month_names: [
      null,
      'januari',
      'februari',
      'maart',
      'april',
      'mei',
      'juni',
      'juli',
      'augustus',
      'september',
      'oktober',
      'november',
      'december',
    ],
    abbr_month_names: [
      null,
      'jan',
      'feb',
      'mrt',
      'apr',
      'mei',
      'jun',
      'jul',
      'aug',
      'sept',
      'okt',
      'nov',
      'dec',
    ],
    order: ['day', 'month', 'year'],
  },
  number: {
    format: {
      separator: ',',
      delimiter: '.',
      precision: 2,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '€',
        separator: ',',
        delimiter: '.',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Bytes',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'duizend',
          million: 'miljoen',
          billion: 'miljard',
          trillion: 'biljoen',
          quadrillion: 'biljard',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'een halve minuut',
      less_than_x_seconds: {
        one: 'minder dan een seconde',
        other: 'minder dan %{count} seconden',
        few: 'less than %{count} seconds',
        many: 'less than %{count} seconds',
      },
      x_seconds: {
        one: '1 seconde',
        other: '%{count} seconden',
        few: '%{count} seconds',
        many: '%{count} seconds',
      },
      less_than_x_minutes: {
        one: 'minder dan een minuut',
        other: 'minder dan %{count} minuten',
        few: 'less than %{count} minutes',
        many: 'less than %{count} minutes',
      },
      x_minutes: {
        one: '1 minuut',
        other: '%{count} minuten',
        few: '%{count} minutes',
        many: '%{count} minutes',
      },
      about_x_hours: {
        one: 'ongeveer een uur',
        other: 'ongeveer %{count} uur',
        few: 'about %{count} hours',
        many: 'about %{count} hours',
      },
      x_days: {
        one: '1 dag',
        other: '%{count} dagen',
        few: '%{count} days',
        many: '%{count} days',
      },
      about_x_months: {
        one: 'ongeveer een maand',
        other: 'ongeveer %{count} maanden',
        few: 'about %{count} months',
        many: 'about %{count} months',
      },
      x_months: {
        one: '1 maand',
        other: '%{count} maanden',
        few: '%{count} months',
        many: '%{count} months',
      },
      about_x_years: {
        one: 'ongeveer een jaar',
        other: 'ongeveer %{count} jaar',
        few: 'about %{count} years',
        many: 'about %{count} years',
      },
      over_x_years: {
        one: 'meer dan een jaar',
        other: 'meer dan %{count} jaar',
        few: 'over %{count} years',
        many: 'over %{count} years',
      },
      almost_x_years: {
        one: 'bijna een jaar',
        other: 'bijna %{count} jaar',
        few: 'almost %{count} years',
        many: 'almost %{count} years',
      },
      x_years: {
        one: '1 jaar',
        other: '%{count} jaar',
      },
      x_weeks: {
        one: '1 week',
        other: '%{count} weken',
        few: '%{count} weeks',
        many: '%{count} weeks',
      },
      x_hours: {
        one: '1 uur',
        other: '%{count} uur',
      },
    },
    prompts: {
      year: 'jaar',
      month: 'maand',
      day: 'dag',
      hour: 'uur',
      minute: 'minuut',
      second: 'seconde',
    },
  },
  page: {
    plus: {
      button: {
        text: 'Upgrade naar Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Tot vijf verschillende afbeeldingen',
        best_2: 'JPEG of PNG',
        best_3: 'Tot %{size}',
        best_4: 'Minimaal %{resolution} pixels',
        best_5: "Geen GIF's of video's (helaas)",
        best_title: 'De details:',
        text: "Zet jezelf of je merk centraal met tot vijf roulerende video's of afbeeldingen:",
        best_five: "%{videoResolution} pixels voor video's",
        best_four: '%{resolution} pixels voor afbeeldingen',
        best_one: "Tot vijf video's of afbeeldingen",
        best_six:
          "Wallpapers wisselen iedere %{rotationInterval} seconden, video's langer dan %{rotationInterval} seconden worden ingekort",
        best_three: 'maximaal %{size} per video/afbeelding',
        best_two: 'JPEG, PNG of MP4',
        notice:
          "Tromgeroffel—video wallpapers zijn een feit! <a href='/profile'>Maak van jouw wallpaper nu een video</a>.",
      },
      upsell: {
        benefit_one_alt: 'Creëer je eigen WeTransfer-pagina',
        heading_alt: 'Lever je werk af met flair',
        benefit_one: 'Creëer je eigen WeTransfer domein',
        benefit_three: 'Ontwerp je eigen transfer e-mails',
        benefit_two:
          'Laat jouw eigen wallpaper zien wanneer anderen je bestanden downloaden',
        button: {
          action: 'Vertel me meer',
        },
        heading: 'Zet je merk in de schijnwerpers met WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send the best.</strong> Make a great impression every time people download your files.<br /> <strong>Receive with ease.</strong> Anyone can upload files to you as part of your plan.',
        protip: {
          text: '<strong>Pro tip:</strong> Requesting a transfer from someone? Share a special link to pre-fill the description for them.',
          link: 'Learn more',
        },
      },
      pagename: 'Branding',
      'onboarding-step-two':
        "Verstuur je bestanden in stijl, personaliseer je WeTransfer-profiel en bewonder je nieuwe look op <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Personaliseer je e-mails',
      sent_you_files: 'heeft je een aantal bestanden gestuurd',
      email_background_instruction_with_spec:
        'Voeg een afbeelding toe om je transfermails te laten opvallen. Upload een afbeelding van %{resolution} pixels voor het beste resultaat (anders wordt je afbeelding bijgesneden). De maximale bestandsgrootte is %{size}.',
      receiving: 'Profiel e-mail',
      choose_wallpapers: 'Voeg je eigen wallpapers toe',
      'step-one-banner':
        "Kies om te beginnen een url voor je WeTransfer-pagina. Je kunt 'm later altijd nog wijzigen.",
      description: {
        pro: 'Met je eigen WeTransfer-pagina maak je een geweldige indruk als mensen je bestanden downloaden. En het is ook de plek waar iedereen jou transfers van 200 GB kan sturen. Dit is onderdeel van het WeTransfer Premium-abonnement.',
        premium:
          'Met je eigen WeTransfer-pagina maak je een geweldige indruk als mensen je bestanden downloaden. En het is ook de plek waar iedereen jou transfers zonder limieten kan sturen. Dit is onderdeel van het WeTransfer Premium-abonnement.',
      },
      'instructions-1': 'Wijzig je naam en url zo vaak als je wilt.',
      'instructions-2':
        'Als je een nieuwe url hebt gekozen, wordt je pagina meteen bijgewerkt.',
      title: 'Bewerk je pagina',
      profile_url: 'URL',
    },
    payment: {
      never_actived_retry:
        'Je account is nog niet actief. Voltooi je registratie om <a href="/payment/retry">%{planName}</a> te gebruiken',
      pagename: 'Abonnement en betaling',
      autorenew_heading: 'Betaalgegevens',
      autorenew_notice:
        'Je %{planName}-abonnement van %{deal} wordt op %{autorenewal_attempt} automatisch verlengd.',
      will_expire_notice:
        "Je Pro-abonnement <span class='payment__notice'>verloopt over %{daysBetween} dagen</span>. Verleng nu je account of stel automatische verlenging in.",
      never_actived_notice:
        'Je account is nog niet actief. <a href="/payment/retry">Voltooi je registratie en ga aan de slag met Pro.</a>',
      manual_renewal_expiry_notice: 'Je Pro account verloopt op %{expiry}.',
      to_checkout: 'Naar betalen',
      updating: 'Bezig met bijwerken...',
      yes_disable: 'Ja, toe maar',
      review_billing_link: 'Je betaalwijze bijwerken?',
      autorenew_failed:
        "Je Pro-abonnement van %{deal}/%{period} <span class='payment__notice'><strong>verloopt over %{daysBetween} dagen</strong>. We konden je account niet voor je verlengen. Verleng je account handmatig vóór <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Weet je zeker dat je de automatische verlenging wilt stoppen?',
      disable_autorenewal: 'Automatische verlenging stoppen',
      enable_autorenewal: 'Automatische verlenging instellen',
      renew_now: 'Nu verlengen',
      subscription_expired: 'Je Pro-abonnement is beëindigd.',
      cancel_heading: 'Tijd voor iets anders?',
      cancel_info:
        'We snappen het hoor, die dingen gebeuren. Zodra je jouw abonnement opzegt, bewaren we je bestanden nog 30 dagen (nee, niet onder ons hoofdkussen – dat zou raar zijn) voor het geval je nog iets vergeten bent. Je kunt ook op ieder moment je abonnement weer activeren.',
      cancel_info_subscription:
        'We snappen het hoor, die dingen gebeuren. Zodra je jouw abonnement opzegt, is je account nog te gebruiken tot %{subscriptionExpiryDate}. Daarna bewaren we je bestanden nog 30 dagen (nee, niet onder ons hoofdkussen – dat zou raar zijn) voor het geval je nog iets vergeten bent. Je kunt ook op ieder moment je abonnement weer activeren.',
      cancel_now: 'Abonnement opzeggen',
      cancelling: 'Bezig met opzeggen...',
      confirm_cancel_subscription:
        'Weet je zeker dat je je abonnement wilt stopzetten?',
      confirm_reactivate_subscription:
        'Uitstekende keuze! Nog maar één klik om je betaalwijze weer te activeren',
      manual_renewal_in_future_notice:
        'Je Pro-abonnement van %{deal}/%{period} verloopt over %{daysBetween} dagen. Verleng je account na %{manual_renewal_available_at} of stel automatische verlenging in.',
      reactivate_heading: 'Laten we opnieuw beginnen.',
      reactivate_content_top_pro:
        'Je kunt je %{planName}-abonnement opnieuw activeren, zodat het lijkt alsof je het nooit hebt opgezegd. Je kunt ook kiezen voor een upgrade naar WeTransfer Premium:',
      reactivate_content_top_premium:
        'Je kunt je %{planName}-abonnement opnieuw activeren, zodat het lijkt alsof je het nooit hebt opgezegd.',
      reactivate_content_bottom_pro:
        'Als je naar Premium upgradet, wordt er %{upfront_payment} in rekening gebracht. Je kunt daarna meteen aan de slag met WeTransfer Premium. Je nieuwe abonnement van %{recurring_payment} per %{interval} wordt verlengd op %{recurring_date}.',
      reactivate_pro: 'Pro weer activeren',
      reactivate_premium: 'Premium weer activeren',
      reactivate_upgrade_to_premium: 'Upgraden naar Premium',
      reactivating: 'Opnieuw activeren...',
      subscription_cancelled:
        'Je abonnement is stopgezet en verloopt automatisch over %{daysBetween} dagen.',
      subscription_reactivate_expired_notice: 'Je Pro-account is opgezegd.',
      subscription_reactivate_notice_pro:
        'Je %{planName}-abonnement is stopgezet en verloopt over %{daysBetween} dagen.',
      subscription_reactivate_notice_premium:
        'Je %{planName}-abonnement is stopgezet en verloopt over %{daysBetween} dagen.\nBen je van gedachten veranderd? Geen paniek, je kan heel gemakkelijk weer aan de slag.',
      subscription_reactivate_notice_trial_before:
        'Je %{planName}-abonnement is stopgezet en verloopt over %{daysBetween} dagen.\nJe kunt je WeTransfer Premium-proefabonnement blijven gebruiken tot je abonnement afloopt.',
      subscription_reactivate_notice_trial_after:
        'Je %{planName}-abonnement is stopgezet en verloopt over %{daysBetween} dagen.\nJe kunt je WeTransfer Premium-proefabonnement blijven gebruiken tot %{trialExpiryDate}.',
      update_method_link: 'Betaalgegevens bijwerken',
      autorenew_notice_teams:
        'Je %{planName}-abonnement van %{deal} zal automatisch worden verlengd voor je team met %{number_of_members} leden op %{autorenewal_attempt}.',
      cancellation_cta: 'Abonnement opzeggen',
      cancellation_heading:
        'Geen behoefte meer aan de voordelen van %{planName}?',
      cancellation_heading_trial: 'Abonnement opzeggen',
      cancellation_text:
        'Als je je abonnement opzegt, kun je nog tot %{subscriptionExpiryDate} gebruikmaken van de functies van Pro. Daarna wordt je WeTransfer Pro-account omgezet naar een gratis account. Je actieve transfers zullen 28 dagen later verlopen.',
      cancellation_text_item_1: 'Tot %{transfer_limit} versturen',
      cancellation_text_item_2: 'Transfers beveiligen met een wachtwoord',
      cancellation_text_item_3:
        '%{storage_limit} aan transfers beheren en opslaan',
      cancellation_text_item_4:
        'Je eigen URL en persoonlijke Pro-pagina gebruiken',
      cancellation_text_item_heading:
        'Met een gratis account kun je maximaal %{free_size_limit} versturen per transfer. Je kunt niet langer:',
      cancellation_text_new:
        'Als je nu je abonnement opzegt, kun je %{planName} gebruiken tot %{subscriptionExpiryDate}. Daarna wordt je account omgezet naar een gratis abonnement.<br /><br />Let op, bestaande transfers vervallen uiterlijk 28 dagen nadat je abonnement is afgelopen.',
      cancellation_text_teams:
        'Als je nu je abonnement opzegt, kunnen jij en je team %{planName} gebruiken tot %{subscriptionExpiryDate}.<br /><br />Daarna kunnen jij en je teamleden niet meer samen transfers versturen, slides maken en boards samenstellen. Je account wordt omgezet naar een gratis abonnement en je kunt alleen inloggen bij je eigen WeTransfer-account.<br /><br />Let op, bestaande transfers vervallen uiterlijk 28 dagen nadat je abonnement is afgelopen.',
      premium_trial: {
        feature_list_item_1: 'Geen limiet op bestandsgrootte voor transfers',
      },
      premium_upgrade: {
        cta: 'Stap over naar Premium',
        description:
          'Je betaalt nu %{upfront_payment} en kan meteen aan de slag met WeTransfer Premium. Je nieuwe abonnement van %{recurring_payment} %{interval} wordt verlengd op %{recurring_date}.',
        feature_list_item_1:
          'Stuur transfers zonder limiet op de bestandsgrootte',
        feature_list_item_2: 'Onbeperkte opslagruimte',
        feature_list_item_3: 'Onbeperkte portals en reviews',
        feature_list_item_4: '%{storageLimit} opslagruimte',
        heading: 'Wil je je abonnement upgraden?',
      },
      unpaid_invoices: {
        heading: 'Er staan nog facturen open.',
        item: {
          issued_on: 'Gemaakt op',
          pay_invoice: 'Factuur betalen',
          pending_invoice: 'Openstaand...',
        },
        subheading:
          'Het lijkt erop dat er een probleem is met je vorige betalingen. Betaal alle openstaande facturen om te voorkomen dat je Pro abonnement wordt geannuleerd.',
        subheading_2:
          'Als je nog openstaande facturen hebt, nog even geduld. We proberen het over een paar dagen opnieuw. Je kunt weer aan de slag als de betaling is gelukt.',
      },
      upgrade_cta: 'Upgraden',
      app_subscription_banner: {
        title: 'Je hebt je geabonneerd via de %{app_name}',
        content:
          'Meld je via je telefoon of computer aan bij je %{app_name}-account om je abonnement te bekijken of beheren.',
        go_to: 'Ga naar',
        learn_more: 'Meer informatie',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Abonnement opzeggen',
      cancellation_disclaimer:
        '*Let op, je actieve transfers zullen uiterlijk 28 dagen nadat je account is omgezet verlopen.',
      'current-plan': 'Huidig abonnement',
      'free-forever': 'Altijd gratis',
      'free-usp-1': 'Verstuur tot 2 GB',
      'free-usp-2': 'Geen opslag',
      'free-usp-3': 'Transfers verlopen na 7 dagen*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Als je je abonnement nu opzegt, kun je nog gebruikmaken van WeTransfer Pro tot <b>%{expiration_date}</b>. Daarna wordt je Pro-account omgezet naar een gratis account – wat nog steeds behoorlijk handig is.',
      pagename: 'Geen behoefte meer aan de voordelen van Pro?',
      'pro-usp-1': 'Ontvang en verstuur tot %{transfer_limit}',
      'pro-usp-2': '1 TB opslag',
      'pro-usp-3': 'Bepaal zelf wanneer je transfers verlopen',
      'pro-usp-4':
        '<p>Je eigen <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro-pagina</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Probeer Paste® Pro en Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Je abonnement is nu opgezegd en je account zal worden omgezet naar een gratis WeTransfer-account na <b>%{ends_at}.</b></p> \n<p>Laat ons weten waarom je weggaat zodat we WeTransfer kunnen blijven verbeteren met jouw input.</p>',
      reason_header: 'We vinden het jammer dat je gaat',
      cancel: 'Ga terug',
      info: 'Laat ons weten waarom je weggaat zodat we WeTransfer Pro kunnen blijven verbeteren met jouw input.',
      pagename: 'Voordat je gaat',
      yes_disable: 'Ja, toe maar',
    },
    payment_failed: {
      selected_product: 'Eén %{duration} %{planTier}',
      change: 'Bijwerken',
      complete_order: 'Voltooi bestelling',
      description: 'Bekijk je gegevens en voltooi je bestelling',
      description_error:
        'Er ging iets mis. Controleer je gegevens en ga naar betalen.',
      description_refused:
        'We konden je betaling niet verwerken. Controleer je betaalgegevens en probeer het nog een keer.',
      discount: 'Korting',
      product_description: 'Een %{duration} WeTransfer Pro',
      title: 'Je bent er bijna!',
      total: 'Totaal',
      vat: 'Btw',
      your_details: 'Je gegevens',
      your_order: 'Je bestelling',
      title_error: 'Hmm, er lijkt een probleem te zijn',
      title_refused: 'Hmm, er lijkt een probleem te zijn',
      payment_status_message:
        'Je betaling is gelukt, maar er is toch iets misgegaan, waardoor we je abonnement niet automatisch konden bijwerken. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Neem contact op met ons supportteam</a>',
    },
    payment_methods: {
      billed_now: 'Gefactureerd',
      info_content: {
        cancel_bullet:
          'Geen zorgen, je kan je abonnement altijd opzeggen via Accountinstellingen > Betaling.',
        initial_payment_bullet:
          'Na de eerste betaling betaal je %{price} %{interval} (tenzij je besluit je abonnement op te zeggen – maar dat doe je niet, toch? Toch?!)',
        update_payment_bullet:
          'Je kan altijd je betalingsgegevens en/of factuurgegevens aanpassen voordat je volgende betaling wordt afgeschreven.',
        month:
          "- Na je eerste betaling wordt er %{price} per maand in rekening gebracht (tenzij je besluit je Pro-abonnement stop te zetten, maar we kunnen ons niet voorstellen waarom je dat zou doen). Maak je geen zorgen, je vindt de optie onder 'Accountinstellingen' > 'Betaling'.\nJe kunt je betaalmethode en/of bedrijfsgegevens altijd bijwerken voordat de volgende betalingsronde plaatsvindt.",
        year: '- Na je eerste betaling wordt er %{price} per jaar in rekening gebracht (tenzij je besluit je WeTransfer Pro-abonnement stop te zetten, maar dat doe je niet, toch? Toch?!) \n- Je kunt je abonnement stopzetten via Accountinstellingen > Betaling. \n- Je kunt je betaal- en/of factuurgegevens altijd aanpassen voordat de volgende betaling verschuldigd is.',
      },
      payment_cta: 'Betaling voltooien',
      payment_term: {
        monthly: 'per maand',
        yearly: 'per jaar',
      },
      payment_title: 'Betaling',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Per maand',
        year: 'Per jaar',
      },
      subtotal: 'Subtotaal',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Je betaalmethode',
      bancontact: 'Bancontact',
      card: 'Creditcard',
      card_cvc: 'CVC',
      card_expiration: 'MM/JJ',
      card_name: 'Naam op creditcard',
      card_number: 'Creditcardnummer',
      complete_payment: 'Betaling afronden',
      creditcard: 'Creditcard',
      discount: 'Korting',
      do_not_refresh: 'Vernieuw of sluit deze pagina niet.',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL is een Nederlandse online betaalwijze waarmee je via je eigen bank de betaling kunt uitvoeren.',
      info: 'Betaalwijze aanpassen',
      payment_in_progress: 'Je betaling wordt verwerkt...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: 'per maand',
        year: 'per jaar',
      },
      select_bank: 'Selecteer je bank',
      select_country: 'Selecteer land',
      sofort: 'SOFORT',
      tax: 'Btw',
      title: 'Selecteer je betaalwijze',
      total: 'Totaal',
    },
    projects: {
      actions: {
        go_back: 'Alle projecten',
        discard: 'Wijzigingen verwijderen',
        edit: 'Bewerken',
        remove_transfer:
          'Deze transfer deleten? Bestanden worden uit dit project en uit verzonden transfers verwijderd.',
        save: 'Opslaan',
        share: 'Delen',
      },
      transfer_actions: {
        download: 'Downloaden',
      },
      added_at: 'om %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Link kopiëren',
        link_copied: 'Link gekopieerd naar klembord',
        content_label: 'Kopieer link naar dit project',
        list_item_1: 'Alleen toegang tot downloaden en bekijken',
        list_item_2: 'Link blijft hetzelfde, voor altijd',
        title: 'Project delen',
      },
      content: {
        empty_state:
          'Je project is op dit moment leeg. Voeg een aantal bestanden toe om je projecttijdlijn te starten.',
      },
      logo_title: 'Ga terug naar wetransfer.com',
      logo_tooltip_caption: 'Terug naar WeTransfer',
      timestamp: '%{timeAgo} geleden',
      chat: {
        owner_button_label: 'Hé… Zeg het maar',
        owner_offline_greeting:
          'We zijn momenteel offline, maar als je ons laat weten waar je problemen mee hebt, nemen we binnen één werkdag contact met je op.',
        owner_online_greeting:
          'Laat ons weten waar je problemen mee hebt en we nemen zo snel mogelijk contact met je op',
        receiver_button_label: 'Vragen? Wij zijn er om je te helpen',
        receiver_offline_greeting:
          'Laat ons weten waar je problemen mee hebt en we nemen zo snel mogelijk contact met je op.',
        receiver_online_greeting:
          'Laat ons weten waar je problemen mee hebt en we nemen zo snel mogelijk contact met je op.',
      },
      created_by: 'Gemaakt door %{user}',
      created_by_fallback: 'Gemaakt',
      deliverable_clipboard_modal: {
        content_label: 'Kopieer link naar deze deliverable',
        info: 'Mensen kunnen ook je project zien',
        title: 'Deel deliverable',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Dit is niet het project waar je naar op zoek bent…',
        limit:
          'Je potentieel laat zich niet beperken, maar het aantal tekens wel',
        required: "Je weet hoe 't werkt. Je moet dit echt even invullen",
      },
      event: {
        project_created_byline:
          'Voeg wat bestanden toe en laat zien waar je mee bezig bent.',
        project_created_title: 'Begin van het project',
      },
      file_count: {
        one: '%{count} bestand',
        other: '%{count} bestanden',
      },
      just_now: 'zojuist',
      labels: {
        description: 'Beschrijving',
        name: 'Naam',
        new_name: 'Geef je project een naam',
      },
      logo: {
        cta: 'Voeg een logo toe',
        errors: {
          dimensions:
            'Je logo is kleiner dan 220 x 220 px. Probeer een grotere afbeelding',
          general: 'Hmm, er ging iets mis. Probeer het nog eens',
          size: 'Je logo is groter dan 5 MB. Probeer een kleiner bestand',
          type: 'Je logo is geen JPEG, GIF of PNG. Probeer een andere afbeelding',
        },
        instructions:
          "Je logo mag maximaal 5 MB zijn. JPEG's en GIF's zijn prima, maar PNG's met een transparante achtergrond werken het beste",
        'instructions-title': 'Laat je merk zien',
      },
      name_modal: {
        content_label: 'Geef je project een (andere) naam',
        input_placeholder_0: 'Echt wel een Cannes Lion',
        input_placeholder_1: 'Een middel tegen verkoudheid',
        input_placeholder_2: 'De perfecte misdaad',
        input_placeholder_3: 'Ik schrijf nummers geen titels',
        input_placeholder_4: 'Bekroond idee',
        input_placeholder_5: 'Gloednieuwe merkcampagne',
        input_placeholder_6: 'World domination',
        save: 'Opslaan',
        text: 'Beschrijf waar je mee bezig bent.',
        title: 'Geef je project een naam',
      },
      new_project_label: 'Begin een nieuw project',
      noticebar: {
        'button-cancel': 'Annuleren',
        'button-clear-all-files': 'Alles wissen',
        'button-close': 'Sluiten',
        'button-delete': 'Verwijderen',
        'button-no': 'Nee',
        'button-share': 'Delen',
        'button-yes': 'Ja',
        'confirm-cancel': 'Deze transfer annuleren?',
        'confirm-clear-files-deliverable':
          'Wis alle bestanden van <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Upload voltooid! Laat iedereen weten dat je meer bestanden hebt toegevoegd.',
        'confirm-delete-deliverable':
          '<strong><u>%{deliverableName}</u></strong> deleten en alle bestanden die je erin hebt gezet?',
        'confirm-first-complete':
          'Upload voltooid! Deel dit project, zodat je bestanden kunnen worden gedownload.',
        deliverable_not_found_error:
          'Hmm, het lijkt erop dat die deliverable is verwijderd',
        general_error: 'Oeps, er ging iets mis. Probeer het opnieuw.',
      },
      'onboarding-promise': {
        description:
          'Maak een samenvatting van al het werk dat je levert voor een project en stroomlijn de manier waarop je deelt. Maak een lijst met deliverables en voeg steeds bestanden toe — geen aparte downloadlinks meer.',
        title: 'Begin op schema en blijf op schema',
      },
      onboarding: {
        banner:
          'Let op! Je bent een van de weinigen met toegang tot Projecten terwijl er nog aan wordt gewerkt (en verbeteringen in worden aangebracht). We vragen je misschien nog om feedback.',
      },
      pagename: 'Projecten',
      placeholders: {
        description: 'Geef een korte beschrijving van je project',
        loading: 'Laden...',
      },
      project: {
        notification: {
          name_saved: 'Naam opgeslagen! Dit wordt vast een succes.',
        },
      },
      share_button_label: 'Delen',
      unnamed_project_title: 'Naamloos project',
      watch_video: 'Bekijk video',
    },
    transfer: {
      display_name_fallback: 'Naamloze transfer',
      does_not_expire: 'geen <u>verloopdatum</u>',
      expires_in: 'Verloopt over <span>%{time}</span>',
      downloaded_at: 'Gedownload op %{date}, om %{time}',
      not_downloaded: 'Nog niet gedownload',
      email_bounced:
        'Hmm, het e-mailadres waar je dit naar hebt gestuurd, werkt niet',
      count_files: {
        one: '%{count} bestand',
        other: '%{count} bestanden',
      },
      sent_datetime: 'Verstuurd op %{date} om %{time}',
      never_expires: 'Geen verloopdatum',
      and_more: 'Nog %{count}',
      read_more: 'meer',
      copy_link: 'kopieer link',
      message: 'Bericht',
      total_downloads: 'Totaal aantal downloads',
      sent_to_recipients: {
        one: 'Verstuurd naar %{count} persoon',
        other: 'Verstuurd naar %{count} personen',
      },
      no_transfers: 'Alle transfers die je verstuurt, vind je hier terug',
      add_first_description:
        'Stuur een transfer door, pas aan of verwijder en check wie jouw transfer gedownload heeft',
      mobile: {
        download: 'Alle bestanden downloaden',
        remove: 'Transfer verwijderen',
      },
      delete_datetime: 'Bestanden verwijderd op %{date} om %{time}',
      detail: {
        plus_download_stats:
          'Neem Pro en hou bij hoe vaak je transfers worden gedownload.',
        plus_password_expiration:
          'Neem Pro en voeg wachtwoorden en vervaldata toe aan je transfers.',
        plus_transfer_actions:
          'Neem Pro en beheer of verwijder je transfers wanneer je maar wilt.',
        title: 'Jouw transfergegevens',
      },
      download_status_email: '%{count} van de %{total} personen',
      download_status_email_text: {
        zero: 'Nog niet gedownload',
        one: '%{count} van de %{total} personen',
        other: '%{count} van de %{total} personen',
      },
      download_status_link: {
        one: 'één keer',
        other: '%{count} keer',
      },
      download_status_link_text: {
        zero: 'Nog niet gedownload',
        one: '1 keer',
        other: '%{count} keer',
      },
      sent_moment: 'Verzonden %{moment}',
      total_downloads_tooltip:
        'Anders dan je had verwacht? We hebben onlangs een kleine verandering doorgevoerd. Hier zie je alleen het aantal voltooide downloads.',
      display_name: {
        label: 'Titel',
        label_mobile:
          'Voeg een titel toe zodat mensen weten wat er in je transfer zit',
      },
      download_status_received_text: {
        zero: 'Nog niet gedownload',
        one: 'Gedownload',
        other: 'Gedownload',
      },
      edit_display_name: {
        cancel: 'Annuleren',
        save: 'Opslaan',
        title: 'Titel',
      },
      received_datetime: 'Ontvangen op %{date} om %{time}',
      received_from: 'Ontvangen van',
      received_moment: 'Ontvangen %{moment}',
      teams: {
        received_by: 'Ontvangen door',
        self: 'mij',
        sent_by: 'Verstuurd door',
      },
      title: 'Titel',
      set_password: {
        added: 'Toegevoegd',
        change: 'Wijzigen',
        remove: 'Verwijderen',
        description:
          'Stel een wachtwoord in om te bepalen wie toegang heeft tot deze transfer.',
        remove_warning: 'Wachtwoordbeveiliging van deze transfer verwijderen?',
        yes_remove: 'Ja, verwijderen',
      },
      set_expiration: {
        description:
          'Stel een vervaldatum in om de toegang tot deze transfer te beperken.',
        label: 'Verloopt over',
      },
      anon_upsell_no_account:
        '<a href="%{href}">Meld je gratis aan</a> om de downloads voor deze overdracht te bewerken of op te volgen vóór de vervaldatum.',
      anon_upsell_found_account:
        '<a href="%{href}">Log in</a> om de downloads voor deze transfer te bewerken of op te volgen vóór de vervaldatum.',
      anon_upsell_no_account_with_button:
        'You can edit this transfer before it expires by creating an account.',
      create_free_account: 'Create free account',
    },
    transfers: {
      space_used_unlimited: ' %{space} van opslag gebruikt',
      pagename: 'Transfers',
      search: 'zoeken op bestandsnaam',
      search_results: {
        one: '%{count} zoekresultaat',
        other: '%{count} zoekresultaten',
        none: 'Niets gevonden',
        retry:
          'We konden geen transfer vinden op basis van je zoekopdracht - probeer het nog eens.',
      },
      space_used: '%{space} van %{totalSpace} gebruikt',
      selected_text: {
        one: '%{count} transfer geselecteerd (%{size})',
        other: '%{count} transfers geselecteerd (%{size})',
      },
      last_7_days: 'In de afgelopen 7 dagen verstuurd',
      over_7_days: 'Meer dan 7 dagen geleden verstuurd',
      sort_on: 'Sorteren op:',
      size: 'Grootte',
      name: 'Naam',
      date: 'Datum',
      delete: 'Verwijderen',
      download: 'Downloaden',
      forward: 'Doorsturen',
      remove: 'Verwijderen',
      select: 'Selecteren',
      copy_link: 'Kopieer link',
      sent_time_ago: '%{timeAgo} geleden verstuurd',
      files: {
        one: '%{count} bestand',
        other: '%{count} bestanden',
      },
      confirm_transfer_delete:
        'Weet je zeker dat je deze transfer wilt verwijderen?',
      confirm_forward:
        'Je bent al met een transfer bezig, wil je die transfer vervangen?',
      confirm_expired_transfer_delete:
        'De bestanden en gegevens van de transfer worden voorgoed verwijderd. Doorgaan?',
      deleting_now: 'We verwijderen dit nu voor je',
      deselect_all_transfers: {
        one: 'Alle transfers deselecteren',
        other: 'Alle %{count} transfers deselecteren',
      },
      downloads: 'Downloads',
      expiration: 'Vervaldatum',
      expiration_next: 'Vervalt in de komende %{days}',
      expiration_no_date: 'Geen vervaldatum',
      expiration_not_soon: 'Vervalt voorlopig niet',
      include_archived_switch_label:
        'Inclusief gegevens voor verwijderde transfers',
      include_archived_switch_tooltip:
        'Deze tellen niet mee voor je opslaglimiet',
      notify_completed: 'Je transfer is klaar. Je kan dit venster sluiten.',
      preview: 'Voorbeeld',
      remove_permanently: 'Gegevens voorgoed verwijderen',
      search_placeholder: 'Zoek op bestandsnaam of e-mail',
      select_all_transfers: {
        one: 'Alle transfers selecteren',
        other: 'Alle %{count} transfers selecteren',
      },
      space_left: '%{space} van %{totalSpace} resterend',
      teams_tip: {
        subtitle:
          'Op deze pagina zie je alleen je eigen transfers. Mocht je het je afvragen: je teamleden kunnen ook alleen hun eigen transfers zien.',
        title: 'Je Pro-team groeit…',
      },
      title: 'Verstuurde transfers',
      view_details: 'Details weergeven',
      edit_display_name: 'Titel bewerken',
      received_time_ago: '%{timeAgo} geleden ontvangen',
      search_title_placeholder: 'Zoek op titel, bestandsnaam of e-mail',
      see_all: 'Alles bekijken (%{count})',
      sender: 'Afzender',
      sort_by_title: 'Titel',
    },
    accountinfo: {
      pagename: 'Accountgegevens',
      signed_in_as: 'Ingelogd als %{name}',
      sign_out: 'Uitloggen',
      paid_on: 'Betaald op',
      no_invoices:
        'Je facturen komen hier te staan, maar zo te zien heb je er nog geen. Bofkont!',
      subscription_info:
        'Je Pro-abonnement van %{deal} wordt op %{autorenewal_attempt} automatisch verlengd.',
      payment_success: {
        monthly: 'Mooi! Je kunt aan de slag met een maand WeTransfer Pro.',
        monthly_renewal: 'Mooi! Je kan weer door met nog een maand Pro.',
        yearly: 'Mooi! Je kunt aan de slag met een jaar WeTransfer Pro.',
        yearly_renewal: 'Mooi! Je kan weer door met nog een jaar Pro.',
      },
    },
    changepassword: {
      pagename: 'Wachtwoord wijzigen',
    },
    invoices: {
      pagename: 'Facturen',
    },
    reviewbilling: {
      pagename: 'Bevestig je betaalgegevens',
      information:
        'Om je betaalwijze te veranderen, moeten we ook je abonnement verlengen',
      information_payment:
        'We brengen %{deal} in rekening voor de komende %{period} Pro. Je abonnement is geldig tot %{expiry}.',
    },
    renewbilling: {
      pagename: 'Controleer je informatie en verleng',
    },
    link_downloads_unsubscribe: {
      body: 'Je kunt je afmelden voor notificaties over downloads van transferlinks. In je overzicht met verstuurde transfers kun je nog steeds zien wat er gedownload is.',
      cta: 'Ga naar mijn verzonden transfers',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Kies uit onze galerij',
        },
        next_button: 'Afronden',
        description:
          "Kies een wallpaper en bepaal zelf hoe je profiel en je downloadpagina's eruit zien. Je kunt je eigen foto's uploaden of een van onze wallpapers kiezen.",
      },
      upload_wallpaper: {
        add_text: 'Afbeelding uploaden',
        add_description:
          'Voor het beste resultaat, kies een afbeelding van 2560 x 1600 pixels met een maximaal bestandsformaat van 3MB.',
        upload_text: 'Upload een afbeelding of video',
      },
      preview: {
        wallpaper_credits_prefix: 'Wallpaper door',
      },
      1: {
        description:
          '&quot;Bepaal zelf wat mensen zien wanneer je ze bestanden stuurt. En dankzij je eigen WeTransfer-pagina kan iedereen je %{transfer_limit} transfers sturen. Geef ze gewoon je URL. Je e-mailadres wordt op de pagina weergegeven, zodat iedereen zeker weet dat bestanden naar jou worden verstuurd.<br /><br />\nKies eerst je URL.&quot;',
        next: 'Volgende',
        skip: 'Sla over',
        warning:
          '<strong> Let op,</strong> je kan dit maar één keer doen (no pressure)',
        'blurb-1':
          'Maak je eigen WeTransfer-pagina. Het ziet er professioneel uit als iemand je bestanden downloadt, en anderen kunnen je nu (nog) gemakkelijker transfers sturen.',
        'blurb-2': 'Kies eerst een url.',
        welcome: 'Laat je zien met je eigen WeTransfer-pagina',
        information:
          "Geen zorgen, je kunt 'm later altijd nog wijzigen bij <strong>Branding</strong>.",
        description_unlimited:
          'Bepaal zelf wat mensen te zien krijgen waneer je ze bestanden stuurt. En met je eigen WeTransfer-pagina kan iedereen je bestanden sturen van elke grootte – je hoeft ze alleen je eigen url te geven. Je e-mailadres wordt op de pagina getoond zodat mensen zeker weten dat hun bestanden bij jou belanden. <br /><br /> \nKies eerst je url.',
      },
      2: {
        description:
          'Je kan tot vijf verschillende achtergronden (of wallpapers, zo noemen wij ze) selecteren voor je profiel.\n\nZet jezelf of je merk centraal en verstuur bestanden in jouw eigen stijl',
        pick: 'Kies uit galerij',
        title: 'Maak indruk met iedere transfer',
        upload: 'Upload zelf',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> is helemaal klaar. Je kunt die link toevoegen aan je website zodat mensen je %{transfer_limit} transfers kunnen sturen. Je kunt natuurlijk ook zelf dingen versturen.',
        done: 'Klaar',
        title: 'Wat een fabuleus profiel',
        description_unlimited:
          '<strong>%{customLink}</strong> is helemaal klaar. Je kan deze link toevoegen aan je website zodat mensen je transfers van elke grootte kunnen sturen – of je kan, eh, zelf iets versturen.',
      },
    },
    contact: {
      add_contact: 'Contact toevoegen',
      add_first_description:
        'We bewaren automatisch de e-mailadressen waarnaar je bestanden verstuurt',
      add_to_transfer: 'Toevoegen aan transfer',
      remove_from_transfer: 'Verwijderen uit transfer',
      confirm_delete: {
        one: 'Weet je zeker dat je dit contact wilt verwijderen?',
        other: 'Weet je zeker dat je deze %{count} contacten wilt verwijderen?',
      },
      contact_count: {
        one: '%{count} contact',
        other: '%{count} contacten',
      },
      edit: 'Bewerken',
      mobile: {
        add: 'Contact toevoegen',
      },
      no_contacts: 'Voeg je eerste contact toe!',
      pagename: 'Contacten',
      remove: 'Verwijderen',
      search_count: {
        one: '%{count} zoekresultaat',
        other: '%{count} zoekresultaten',
      },
      search_placeholder: 'zoeken op e-mail, naam of bedrijf',
      select: 'Selecteren',
      selected_text: {
        one: '%{count} contact geselecteerd',
        other: '%{count} contacten geselecteerd',
      },
      teams_tip: {
        subtitle:
          'Als je iemand een transfer stuurt, wordt hij of zij automatisch toegevoegd aan je contactenlijst. Iedereen in je team kan een eigen lijst maken.',
        title: 'Je Pro-team groeit…',
      },
    },
    unsubscribeexpiration: {
      button: 'Afmelden',
      button_unsubscribed: 'Terug naar WeTransfer',
      description:
        'Sturen we je te veel e-mails? Geen probleem, dan herinneren we je niet meer aan transfers die bijna verlopen.',
      description_unsubscribed:
        'Je ontvangt geen e-mails meer over verlopen transfers',
      no_email: 'je',
      title: 'Afmelden',
      title_unsubscribed: 'Je bent afgemeld',
      downloaded: {
        body: 'Begrepen. Je kunt je afmelden voor de herinneringen over bijna verlopen transfers waarvan de bestanden al gedownload zijn. Dit heeft geen invloed op de de herinneringen die we je sturen over nog niet-gedownloade bestanden.',
        cta: 'Afmelden',
        title:
          '"Mijn bestanden zijn gedownload, ik wil geen e-mails over bijna verlopen transfers"',
      },
      not_downloaded: {
        body: 'Geen probleem. Je kunt je afmelden voor herinneringen over bijna verlopen transfers, ook al zijn je bestanden nog niet gedownload.',
        cta: 'Afmelden',
        title: 'Wil je geen e-mails meer over bijna verlopen transfers?',
      },
      pro: {
        body_1:
          'Dat is prima, je kunt je gewoon afmelden voor deze herinneringen. In je transfergegevens kan je nog steeds in de gaten houden wanneer je transfers verlopen. Ook kun je de verloopdatum altijd aanpassen.',
        body_2:
          'Hé, je kunt ons bereiken op <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> als je van gedachten verandert of ergens mee zit. Geen probleem, joh!',
        cta: 'Afmelden',
        title: 'Wil je geen e-mails meer over bijna verlopen transfers?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Weet je zeker dat je je cookies wilt wissen?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Upgrade nu naar Pro voor %{currency}%{price}/maand',
      },
    },
    advertise: {
      gallery: {
        preview: 'Voorbeeld',
      },
      guidelines: {
        advert_static: {
          title: 'Stilstaande achtergron',
        },
      },
    },
    billinginfo: {
      pagename: 'Factuurgegevens',
    },
    help: {
      button_all_answers: 'Meer antwoorden',
      page_title: 'Snelle hulp',
      read_more: 'Meer informatie',
      search_button: 'Zoeken',
      search_placeholder: 'Waar kunnen we je mee helpen?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Laden...',
    },
    payment_update: {
      bancontact: {
        info: 'Goed om te weten – om te checken of je bankgegevens kloppen, schrijft Bancontact eenmalig € 0,01 af',
      },
      confirm_update: 'Bevestig',
      ideal: {
        info: 'Goed om te weten – om te checken of je bankgegevens kloppen, schrijft iDEAL eenmalig € 0,01 af',
      },
      info: 'Let op - om je gegevens te controleren brengt iDEAL eenmalig €0,01 in rekening',
      sofort: {
        info: 'Goed om te weten – om te checken of je bankgegevens kloppen, schrijft SOFORT eenmalig € 0,01 af',
      },
      title: 'Betaalgegevens bijwerken',
      update_in_progress: 'Bezig met bijwerken...',
    },
    sign_in: {
      account: 'Heb je nog geen account?',
      upgrade: 'Upgrade naar WeTransfer Pro',
    },
    signin: {
      account_cta: 'Maak een account',
      account_item_1: 'Verstuur tot %{size_limit}',
      account_item_2: 'Beheer transfers',
      account_item_3: 'Bewaar tot %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Neem WeTransfer Pro',
      plus_item_1: 'Verstuur tot %{size_limit}',
      plus_item_2: 'Beheer transfers',
      plus_item_3: 'Bewaar tot %{storage_limit}',
      plus_item_4: 'Jouw eigen wallpapers',
      plus_item_5: 'Een gepersonaliseerde URL',
      plus_item_6: 'Beveilig transfers met een wachtwoord',
      plus_month: 'per maand',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Uitnodiging intrekken',
      },
      invitees: {
        title: 'Uitgenodigd - nog geen reactie ontvangen',
      },
      member: {
        action_demote: 'Beheerdersrol verwijderen',
        action_promote: 'Tot beheerder benoemen',
        action_revoke: 'Uit team verwijderen',
      },
      members: {
        title: 'In jouw team',
      },
      no_access: {
        description: 'We laten je weten wanneer de functie beschikbaar is. ',
        title: 'Oeps, deze functie is nog geheim! ',
      },
      subtitle: {
        members: {
          one: '%{count} teamlid',
          other: '%{count} teamleden',
        },
        pending: '%{pendingCount} uitgenodigd',
      },
      tip: {
        button: 'Meer informatie',
        subtitle:
          'Met het gloednieuwe Pro for Teams hebben we WeTransfer nog verder verbeterd! Je kunt vanaf nu gratis nieuwe leden toevoegen. Gebruik het supersimpele formulier hieronder om je teamleden uit te nodigen – zodra ze accepteren, kun je aan de slag!',
        title: 'Een team ben je nooit alleen...',
      },
      title: 'Teamleden',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Verloopt over %{expiry}',
      },
      recipients: 'Versturen naar',
      upsell: {
        benefit_one: 'Bekijk wanneer je bestanden zijn gedownload',
        benefit_three: 'Controleer je oude transfers en verstuur ze opnieuw',
        benefit_two: 'Bekijk wie je bestanden heeft gedownload',
        button: {
          action: 'Vertel me meer',
          cancel: 'Nee, bedankt',
        },
        heading: 'Beheer je transfers eenvoudig met WeTransfer Pro',
        title: 'Jouw transfer-gegevens',
      },
    },
    transferReceived: {
      'empty-description':
        'Hier vind je alle transfers die naar jou zijn verzonden - geen zorgen, ze verbruiken geen opslagruimte',
      'empty-title': 'Bekijk je transfers',
    },
    unsubscribeonboarding: {
      action: 'Uitschrijven',
      back: 'Terug naar WeTransfer',
      contact:
        'Hé, als je ergens mee zit, kun je ons bereiken via <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> —- geen probleem, joh!',
      done: 'Klaar!',
      message:
        'Schrijf je uit voor de rest van onze welkomstmails — geen zorgen, je zult alle belangrijke e-mails nog wel ontvangen.',
      title: 'Raakt je inbox een beetje vol?',
    },
    userinfo: {
      pagename: 'Persoonlijke gegevens',
    },
    free_onboarding: {
      close: 'Sluiten',
      finish_tour: 'Klaar',
      next: 'Volgende',
      send_files: 'Ga naar bestanden verzenden',
      start_tour: 'Kijk wat we nog meer hebben',
      step_one: {
        body_1:
          'Omdat je je e-mailadres hebt bevestigd voor je account, hoef je dat niet meer elke keer te doen als je een transfer stuurt. Geen verificatiecodes meer!',
        body_2:
          'Al je verzonden en ontvangen transfers op één plek. Bekijk hoe vaak je bestanden zijn gedownload. Verstuur opnieuw, stuur door of verwijder je transfers met één klik.',
        header_1: 'Voor eens en altijd geverifieerd',
        header_2: 'Beheer je transfers',
        subtitle:
          'Zeg maar dag tegen verificatiecodes en kwijtgeraakte downloadlinks. Met je nieuwe account kun je op de eenvoudigste manier grote bestanden versturen, gratis.',
        title_1: 'Verstuur bestanden <strong> op jouw voorwaarden</strong>',
        title_2: 'met WeTransfer',
      },
      step_three: {
        body_1:
          'Of het nou een video op je telefoon of een link op je bureaublad is, bewaar al je inspiratie op één plek. Open Collect met de launcher (dat ding in de linker bovenhoek) of gebruik onderstaande link om te beginnen.',
        cta: 'Ga naar Collect',
        title_1: '<strong>Verzamel inspiratie</strong> waar je ook bent',
        title_2: 'met Collect',
      },
      step_two: {
        body_1:
          'Pitch ideeën. Laat zien waar je mee bezig bent. Blijf op één lijn. Zonder ooit nog een slide te hoeven opmaken. Open Paste met de launcher (dat ding in de linker bovenhoek) of gebruik onderstaande link om te beginnen.',
        cta: 'Ga naar Paste',
        title_1: 'Maak <strong>slides in een paar seconden</strong>',
        title_2: 'met Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Probeer portals uit',
        pill: 'Gloednieuwe functie',
        text: "Maak kennis met <strong>portals</strong>, een eenvoudigere manier om feedback en goedkeuring te krijgen. Nodig klanten en collega's uit om bestanden te bekijken en hun favorieten te selecteren – zonder iets te hoeven downloaden.",
        title: 'Deel werk. Krijg feedback. Allemaal op één plek.',
      },
    },
    not_found: {
      body: 'Ga terug naar <a href="https://wetransfer.com/">wetransfer.com</a> of vrolijk jezelf op met <a href="https://wepresent.wetransfer.com/">een van onze mooie verhalen</a>.',
      image_alt: 'Er ging iets mis',
      title: 'Oeps, pagina niet gevonden.',
    },
    password_and_security: {
      title: 'Wachtwoord en beveiliging',
      'two-factor-authentication': {
        description: {
          enabled: 'Sinds %{date}',
        },
        disable: 'Uitschakelen',
        done: 'Klaar',
        enable: 'Activeren',
        get_recovery_codes: 'Herstelcodes ophalen',
        next_step: 'Volgende',
        recovery_code_action: 'Nieuwe codes aanmaken.',
        recovery_code_keep_safe:
          'Je kunt elke code maar één keer gebruiken, maar je kunt er altijd meer krijgen als je ze nodig hebt.',
        recovery_code_need_more:
          'Meer herstelcodes nodig? Je kunt altijd nieuwe aan laten maken. Hou er wel rekening mee dat je huidige codes dan niet meer geldig zijn.',
        recovery_code_title: 'Jouw herstelcodes',
        require_password_action: 'Invoeren',
        require_password_text: 'Voer wachtwoord in om verder te gaan',
        step_one_action: {
          app_store: 'Download in de App Store',
          google_play: 'Download op Google Play',
        },
        step_one_label: 'Stap 1 (van 3)',
        step_one_text:
          'Je hebt straks een authenticatie-app nodig. Als je Google Authenticator (of een andere app) al gedownload hebt, klik dan op volgende.',
        step_one_title: 'Google Authenticator downloaden',
        step_three_label: 'Stap 3 (klaar!)',
        step_three_text:
          'Als je wilt inloggen maar je telefoon niet bij je hebt (kan gebeuren), dan kun je een van deze herstelcodes gebruiken. We slaan deze codes niet voor je op en laten ze niet nog een keer zien, dus bewaar ze ergens op een veilige plek – alsof het de pin van je bankrekening is.',
        step_three_text_2:
          'Bewaar deze codes net zo goed als je pincode! Elke code kan maar één keer worden gebruikt.',
        step_three_title: 'Herstelcodes opslaan',
        step_two_form: {
          error: 'Oeps, die code is verkeerd of verlopen',
          label: 'Verificatiecode',
        },
        step_two_label: 'Stap 2 (je bent er bijna)',
        step_two_text:
          'Gebruik je authenticatie-app om deze barcode te scannen. De app genereert een 6-cijferige verificatiecode; vul deze hieronder in.',
        step_two_text_mobile:
          'Voer de beveiligingssleutel in je authenticatie-app in. De app genereert een 6-cijferige verificatiecode; vul deze hieronder in.',
        step_two_title: 'Scan de barcode',
        step_two_title_mobile: 'Voer beveiligingssleutel in',
        text: {
          protect_account:
            'Gebruik je telefoon om een extra beveiligingslaag aan je account toe te voegen.',
        },
        title: 'Tweefactor-authenticatie',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Het beste uit Paste® en Collect halen',
      },
      cta: 'Nee, ik wil Pro blijven',
      'cta-2': 'Abonnement opzeggen',
      disclaimer: {
        collect: 'Gaat je opslagruimte van 200 GB naar 5 GB in Collect',
        paste: 'Ga je van onbeperkte decks naar 3 decks in Paste®',
        'team-member':
          'Je wordt verwijderd uit %{currentTeam} op WeTransfer Pro.',
        teams:
          'Worden je %{amountOfMembers} teamleden verwijderd uit %{currentTeam} op WeTransfer Pro.',
        title:
          'Wanneer je huidige abonnement eindigt op <strong>%{date}</strong>:',
        'transfer-expiry': 'Worden je huidige transfers verwijderd na 28 dagen',
        'transfer-team-member':
          'Je kunt geen transfers verzenden en ontvangen als onderdeel van het team, en je kunt bestaande teamtransfers niet meer beheren.',
      },
      'password-expiry': {
        title:
          'Transfers beveiligen met een wachtwoord en zelf bepalen wanneer ze vervallen',
      },
      personalization: {
        title: 'Je eigen WeTransfer-pagina personaliseren',
      },
      portals: {
        text: 'Met %{planName} kun je <a href="%{href}" target="_blank">portals</a> gebruiken om werk te delen zodat klanten feedback kunnen geven – zonder iets te downloaden.',
        title: 'Werk delen en feedback krijgen op één plek',
      },
      'stay-pro': 'Abonnement behouden',
      'storage-limit': {
        title: 'Genieten van %{storage_limit_pro} opslag per persoon',
      },
      subtitle: 'Als je nu opzegt, kan je vanaf %{date} niet meer:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Nodig teamleden uit op</a> om samen transfers te versturen, ontvangen en beheren — of werk gratis in je eentje.',
        'team-member-text':
          'Je wordt verwijderd uit je team en je zal niet langer samen transfers kunnne versturen, ontvangen of beheren.',
        'team-owner-text':
          'Je hebt <a href="%{href}" target="_blank">%{amountOfMembers} teamleden</a> die niet meer samen transfers zullen kunnen versturen, ontvangen of beheren.',
        title: 'Aan grote ideeën werken als een team',
      },
      title: 'Weet je zeker dat je %{planName} wil opzeggen?',
      'transfer-limit': {
        text: 'Je kunt nu grotere transfers versturen en ontvangen – echt veel meer dan de gratis %{transfer_limit_free}.',
        title: '100 keer grotere transfers versturen',
      },
      'transfer-unlimited': {
        text: 'Je kan nu transfers versturen (en ontvangen) zonder limiet op bestandsgrootte – oneindig veel meer dan de gratis %{transfer_limit_free}.',
        title: 'Transfers versturen van elke grootte',
      },
    },
    pricing: {
      pro: {
        per_person: 'per persoon',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Account aanmaken',
        current_plan: 'Huidig abonnement',
        sign_up: 'Aanmelden',
        switch_premium: 'Stap over naar Premium',
        switch_pro: 'Stap over naar Pro',
        upgrade: 'Upgraden',
      },
      faq: {
        answers: {
          answer_1:
            'Je kan met WeTransfer Pro of WeTransfer Premium aan de slag zodra je betaling is voltooid. We sturen je ook een bevestigingsmail met je betaalde factuur als bijlage. <br /><br /> \n \nAls Pro- of Premium-gebruiker kan je meteen grotere transfers versturen, portals gebruiken en je eigen WeTransfer-pagina maken. Als je nog transfers hebt openstaan die zijn verstuurd toen je nog een gratis account had, kan je de vervaldatum daarvan aanpassen naar wat je maar wil.',
          answer_2:
            "Als je WeTransfer gebruikt, kan iedereen je bestanden downloaden – ze hoeven niet in te loggen of zich aan te melden. Wel moeten ze akkoord gaan met onze servicevoorwaarden en kunnen we ze vragen om cookies te accepteren, maar dat is alles! <br /><br /> \n \nAls je werk wil delen of wil samenwerken in portals (WeTransfers nieuwste functie), hoeven je klanten en collega's zich niet aan te melden om bestanden te bekijken en te selecteren, opmerkingen toe te voegen, goedkeuring te geven of bestanden te downloaden. Je hoeft alleen teamleden aan je Pro- of Premium-abonnement toe te voegen als je wil dat ze samen met jou reviews kunnen toevoegen en portals kunnen maken.",
          answer_3:
            'Als Pro- of Premium-gebruiker kan je je eigen WeTransfer-pagina maken, waar iedereen je bestanden kan sturen met de maximale transfergrootte van jouw abonnement. Dat betekent dat klanten of collega\'s je de grote bestanden kunnen sturen die je nodig hebt, zonder dat ze een account nodig hebben – alleen de url van je pagina. (Al kunnen we ze wel vragen hun e-mailadres te verifiëren om je te beschermen tegen "buitenlandse prinsen" die je "geld willen sturen").',
          answer_4:
            'Je moet je eerst aanmelden voor WeTransfer Pro of WeTransfer Premium – je kan geen teamleden toevoegen als je een gratis account hebt. En welk abonnement je ook kiest, je teamleden krijgen dezelfde voordelen als jij (je kan dus niet Premium voor jezelf nemen en je teamleden op Pro zetten, bijvoorbeeld). Teamleden kunnen grotere transfers sturen en ontvangen vanaf je WeTransfer-pagina en transfers beheren in één gedeeld overzicht. <br /><br /> \n \nNadat je je hebt aangemeld voor het abonnement dat het beste bij je team past, kan je zoveel teamleden uitnodigen als je wil vanuit je teaminstellingen. Zolang je abonnement actief is, kan je op elk moment leden aan je team toevoegen en verwijderen.',
          answer_5:
            'We accepteren PayPal en creditcards van grote aanbieders zoals Visa, Mastercard en American Express. In sommige landen ondersteunen we ook andere online betaalsystemen. <br /><br /> \n \nJe kan niet betalen met een eenmalige bankoverschrijving, omdat je abonnement elke maand of elk jaar automatisch wordt verlengd. (We sturen je wel een e-mail voordat je abonnement voor het eerst wordt verlengd, zodat je op de hoogte bent).',
          answer_6:
            'Als je niet de onbeperkte opslagruimte van WeTransfer Premium hebt, zal je of wat opslagruimte moeten vrijmaken door een paar van je verzonden transfers te verwijderen, of je abonnement moeten upgraden. Zolang je dat niet doet, kan je geen nieuwe transfers versturen. <br /><br /> \n \nAls je WeTransfer gratis gebruikt, worden al je transfers van maximaal 2 GB na 7 dagen automatisch gewist. Dus maak je geen zorgen, met een gratis account kan je niet over je opslaglimiet heen gaan.',
          answer_6_variant_asterisk:
            'Je moet opslagruimte vrijmaken door enkele van je verzonden transfers te verwijderen of je abonnement te upgraden. Tot dan kun je geen nieuwe transfers verzenden. <br /><br />\n\nAls je een Premium-abonnement hebt en een volume van 5 TB bereikt, kun je contact met ons ondersteuningsteam opnemen voor meer opslagruimte tot een maximale jaarlijkse limiet van 15 TB. <br /><br />\n\nAls je de gratis versie van WeTransfer gebruikt, worden al je verzonden transfers met een volume tot 2 GB automatisch verwijderd na 7 dagen. Je hoeft je dus geen zorgen te maken over het overschrijden van je opslaglimiet.',
          answer_6_variant_limited_storage:
            'Je moet opslagruimte vrijmaken door enkele verzonden transfers te verwijderen of je abonnement te upgraden (tenzij je over een Premium-abonnement beschikt). Tot dan kun je geen nieuwe transfers verzenden. <br /><br />\n\nAls je de gratis versie van WeTransfer gebruikt, worden al je verzonden transfers met een volume tot 2 GB automatisch verwijderd na 7 dagen. Je hoeft je dus geen zorgen te maken over het overschrijden van je opslaglimiet.',
          answer_7:
            'Je abonnement wordt automatisch verlengd (we sturen je een e-mail voordat dit voor het eerst gebeurt), maar je kan op elk moment opzeggen. <br /><br /> \n \nOm over te stappen naar een gratis WeTransfer-account, hoef je alleen maar naar je <strong>Account</strong>-instellingen te gaan en je abonnement op te zeggen. Jij (en je eventuele teamleden) kunnen je Pro- of Premium-abonnement blijven gebruiken tot het einde van je huidige abonnementsperiode.',
          answer_8:
            'Miljoenen mensen over de hele wereld vertrouwen op WeTransfer en onze tools om hun ideeën in beweging te brengen. Elke maand delen 80 miljoen mensen 2 miljard bestanden via ons platform. <br /><br /> \n \nOm je ideeën veilig te houden, worden je bestanden versleuteld wanneer ze worden verstuurd (TLS) en opgeslagen (AES-256). Als je bestanden eenmaal zijn opgeslagen, zijn ze alleen te openen via de unieke links die naar de verzender en ontvanger zijn gestuurd.',
        },
        questions: {
          question_1: 'Wat gebeurt er nadat ik me heb aangemeld en betaald?',
          question_2:
            "Moeten de ontvangers van m'n transfers zich ook aanmelden?",
          question_3: 'Kan iedereen me grotere transfers sturen? ',
          question_4: 'Hoe kan ik teamleden toevoegen (en verwijderen)?',
          question_5: 'Welke betaalmethoden kan ik gebruiken?',
          question_6: "Wat gebeurt er als ik m'n opslaglimiet overschrijd?",
          question_7: "Hoe kan ik m'n abonnement stopzetten?",
          question_8: 'Kan ik WeTransfer vertrouwen? Hoe veilig is het?',
        },
        title: 'FAQ',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Advertenties (en kunst)',
            custom: 'Upload je eigen achtergrond',
            feature_1: 'Persoonlijke WeTransfer-pagina',
            feature_2: 'Achtergrondafbeeldingen',
            feature_3: 'Persoonlijke WeTransfer-mails',
          },
          title: 'Laat je merk zien',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} opslag',
            title: 'Collect van WeTransfer',
          },
          paste: {
            limited_decks:
              'Tot %{pasteDecksLimit} decks met het standaard Paste-logo',
            title: 'Paste® van WeTransfer',
            unlimited_decks: 'Onbeperkte decks met je eigen branding',
          },
          title: 'Maak je creatieve toolkit compleet',
        },
        expiry: 'Transfers verlopen na %{days} dagen',
        extra_storage: 'Extra %{storageLimit} per persoon',
        monthly_price: '%{price} per maand per persoon',
        portals: {
          features: {
            feature_1: 'Portals',
            feature_2: 'Reviews',
            feature_3: 'Klantenbranding',
          },
          title: 'Deel werk voor feedback en goedkeuring',
        },
        security: {
          features: {
            feature_1: 'Zelf de vervaldatum instellen',
            feature_2: 'Beveilig transfers met een wachtwoord',
            feature_3: 'Dataversleuteling',
            feature_4: 'Twee-factorauthenticatie',
          },
          title: 'Beveilig je transfers',
        },
        storage_limit: '%{storageLimit} per persoon',
        teams: {
          features: {
            feature_1: 'Nodig teamleden uit',
            feature_2: 'Gedeeld transferoverzicht',
            feature_3: 'Gedeelde opslagruimte',
            feature_4: 'Gedeelde branding',
          },
          title: 'Verstuur werk als een team',
          subtext: {
            text: 'Wordt alleen ondersteund als je een abonnement op onze website neemt.',
            learn_more: 'Meer informatie',
          },
        },
        tooltips: {
          tooltip_1:
            'Alle transfers die je verstuurt tellen voor je opslagruimte',
          tooltip_10:
            'Je kan veilig bestanden versturen en ontvangen met TLS- en AES-256-versleuteling',
          tooltip_11: 'Hou downloads bij en beheer samen je transfers',
          tooltip_12:
            'Laat je (team)werk zien met gepersonaliseerde achtergronden en e-mails',
          tooltip_13:
            'Paste is een presentatietool die decks voor je ontwerpt met automatisch aangepaste kleuren, uitlijning en lay-out.',
          tooltip_14:
            "Met Collect kan je afbeeldingen, video's, muziek en links bewaren en ordenen op al je apparaten.",
          tooltip_2:
            'Mensen kunnen je bestanden downloaden zonder inloggen of aanmelden',
          tooltip_3: 'Hou bij wie je bestanden heeft gedownload (en wie niet)',
          tooltip_4: 'Orden al je werk voor elke klant en project',
          tooltip_5:
            'Nodig klanten uit om bestanden te bekijken en beoordelen, opmerkingen toe te voegen en goedkeuring te geven — allemaal zonder iets te downloaden.',
          tooltip_6:
            'Voeg een logo en titel toe om je portals te personaliseren voor elke klant',
          tooltip_7:
            'Je WeT`ransfer-pagina is de plek waar mensen je bestanden downloaden en je transfers kunnen sturen met de bestandsgroottelimiet van jouw abonnement',
          tooltip_8:
            "Achtergronden zijn de video's en afbeeldingen die je op de achtergrond ziet wanneer je bestanden verstuurt en ontvangt op wetransfer.com",
          tooltip_9:
            'Wow, we dachten eigenlijk niet dat iemand dit zou lezen — lekker bezig! Als je een screenshot post, wordt dat misschien wel geretweet door @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Maximale bestandsgrootte',
            feature_2: 'Opslag',
            feature_3: 'Downloads zonder account',
            feature_4: 'Hou downloads bij',
            feature_5: 'iOS-app',
          },
          title: 'Verstuur grote bestanden',
        },
        unlimited: 'Onbeperkt',
        yearly_price: '%{price} per jaar per persoon',
      },
      header: {
        subtitle:
          'Of je nou grote bestanden verstuurt voor jezelf of opdrachten aflevert aan klanten — met WeTransfer blijven je creatieve projecten in beweging.',
        title: {
          english_1: 'Jij de ideeën,',
          english_2: 'wij de abonnementen',
          general: 'Abonnementen & prijzen',
        },
      },
      plans: {
        billing: {
          discount: 'Bespaar %{percentage} (yes!)',
          monthly: 'Betalen per maand',
          yearly: 'Betalen per jaar',
        },
        free: {
          subtitle: 'Af en toe bestanden versturen',
          title: 'Gratis',
          usp: {
            feature_1: 'Verstuur tot %{transferLimit}',
            feature_2: 'Transfers versturen zonder te verifiëren',
          },
        },
        premium: {
          subtitle: 'Je werk onbeperkt delen',
          title: 'Premium',
          usp: {
            feature_1: 'Geen limiet op bestandsgrootte',
            feature_2: 'Onbeperkte opslagruimte',
            feature_2_subtitle:
              '*De initiële limiet bedraagt %{storageLimit} , met de mogelijkheid om op verzoek extra opslagruimte toe te voegen. Er geldt een maximale jaarlijkse limiet van %{annualStorageLimit}. Raadpleeg onze <a href="/legal/terms" data-route-type="premium" target="_blank">Servicevoorwaarden</a> voor meer informatie.',
            feature_3: 'Onbeperkte portals en reviews',
          },
        },
        pro: {
          subtitle: 'Regelmatig écht grote bestanden versturen',
          title: 'Pro',
          usp: {
            feature_1: 'Verstuur en ontvang tot %{transferLimit}',
            feature_2: '%{storageLimit} opslag per persoon',
            feature_3: '%{portalsLimit} portal, onbeperkte reviews',
          },
        },
        tagline: {
          free: 'geen geld, geen probleem',
          monthly: 'per maand per persoon',
          yearly: 'per jaar per persoon',
          per_person_monthly: 'per persoon, maandelijks gefactureerd',
          per_person_yearly: 'per persoon, jaarlijks gefactureerd',
          tax_included: 'inclusief belasting',
        },
        title: 'Kies je abonnement',
        month: 'maand',
      },
      skip_link: 'Bekijk meer functies',
    },
    pro_classic: {
      hero: {
        cta_1: 'Meer weten',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Jij hebt de ideeën, wij de abonnementen',
      },
      cta: 'Ik wil alleen bestanden versturen',
      free_panel: {
        cta: 'Aanmelden',
      },
      plan: {
        free: {
          feature_1: 'Verstuur tot <strong>%{transfer_limit}</strong>',
          feature_2: 'Transfers versturen zonder te verifiëren',
          subtitle_new: 'Voor de occasionele gebruiker',
          title: 'Gratis',
        },
        pro: {
          feature_1:
            'Verstuur en ontvang tot <strong>%{transfer_limit}</strong>',
          feature_2: 'Bepaal zelf wanneer transfers verlopen',
          feature_5: '1 TB opslag per persoon',
          subtitle_new: 'Voor professionals en teams',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Nu registreren',
          descripttion: 'Houd je transfers in de gaten',
          feature_1: 'Verstuur tot 2 GB',
          feature_2: 'Ontvang transfers in één overzicht',
          title: 'Gratis',
        },
        pro: {
          cta: 'Meer informatie',
          descripttion: 'Haal het beste uit WeTransfer',
          feature_1: 'Verstuur en ontvang tot %{transfer_size}',
          feature_2: '%{storage_size} opslag voor transfers per persoon',
          feature_3: 'Verstuur transfers met aangepaste instellingen',
          title: 'Pro',
        },
        title: 'Voorkom dat transfers worden bedolven in je inbox.',
      },
      title: 'Haal alles uit het nieuwe WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Team uitnodigen',
        pagename: 'Team uitnodigen',
      },
      manage: {
        cta: 'Team beheren',
      },
      members:
        'Je hebt %{amountOfMembers} teamleden. <a href="%{href}">%{cta}</a>',
      no_members: 'Je bent nog de enige! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Team-instellingen',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Vorm een team en verstuur samen transfers',
        context:
          'Verstuur en ontvang transfers als een team met gedeelde opslag, branding en toegang tot elkaars transfers.',
        invite_team: 'Team uitnodigen',
        dismiss: 'Misschien later',
      },
      feature_highlight: {
        free_context:
          'Je kan nu je verstuurde en ontvangen transfers beheren in één simpel overzicht. Weet het meteen als je bestanden zijn gedownload. Verstuur opnieuw, stuur door of download je transfers met één klik. Zo simpel is het',
        free_subtitle: 'Al je transfers op één plek',
        paste_collect_link:
          'Ga naar <a href="%{pasteUrl}" rel="external">%{pasteName}</a> of <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Je kan nu transfers van elke grootte versturen, en je persoonlijke <b>WeTransfer-pagina</b> aanmaken om in te stellen wat mensen zien als ze je bestanden downloaden. Klaar om je eigen url en achtergronden te kiezen?',
        premium_cta: 'Pagina aanmaken',
        premium_dismiss: 'Misschien later',
        premium_subtitle: 'Stel je WeTransfer-pagina in',
        premium_team_context:
          'Je kan nu transfers van elke grootte versturen en ontvangen via de eigen WeTransfer-pagina van je team.',
        pro_context:
          'Je kan nu tot %{transfer_limit} versturen per transfer, en je persoonlijke <b>WeTransfer-pagina</b> aanmaken om in te stellen wat mensen zien als ze je bestanden downloaden. Klaar om je eigen url en achtergronden te kiezen?',
        pro_team_context:
          'Je kan nu transfers tot %{transfer_limit} versturen en ontvangen via de <b>eigen WeTransfer-pagina</b> van je team.',
        send_cta: 'Ga naar bestanden versturen',
        team_subtitle: 'Verstuur creatief werk als een team',
      },
      marketing: {
        context:
          'Nu we wat weten over jou, willen we je graag wat meer vertellen over onszelf. Wil je verhalen over creativiteit en het laatste nieuws over WeTransfer ontvangen?',
        image_alt_text:
          'Voorbeeld van e-mailinhoud, inclusief nieuwe productfuncties, rapporten over de creatieve industrie en WePresent-artikelen met verhalen over creativiteit.',
        opt_in: 'Ja, graag',
        opt_out: 'Nee, bedankt',
        unsubscribe: 'Je kan je altijd later weer afmelden — geen probleem.',
      },
      welcome: {
        context:
          'Door jou beter te leren kennen kunnen wij onze diensten verbeteren.',
        cta: 'Doorgaan',
        dismiss: 'Overslaan',
        dropdown_options: {
          architecture: 'Architectuur/bouw',
          data: 'Data/financiën/juridisch',
          design: 'Design/illustratie',
          education: 'Onderwijs/training',
          marketing: 'Marketing/PR',
          music: 'Muziek/audio',
          other: 'Anders (en er trots op)',
          photography: 'Fotografie',
          product: 'Productontwikkeling/software',
          sales: 'Sales/klantcontact',
          video: 'Video/animatie',
        },
        free_tier_title: 'Welkom bij WeTransfer, %{name}!',
        placeholder: 'Hmmm, even kijken...',
        question: 'Om te beginnen: in welke branche werk je?',
        team_title: 'Je zit in het team, %{name}!',
        tier_title: 'Welkom bij WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Laat WeTransfer de gegevens die je deelt gebruiken om afgestemde advertenties op onze websites en op andere websites weer te geven.',
          tooltip_anchor: 'Wat betekent dit?',
          tooltip: {
            title: 'Hoe gebruikt WeTransfer mijn gegevens?',
            p1: 'We gebruiken je e-mailadres om jou (en anderen zoals jij) WeTransfer-advertenties te tonen op websites die je bezoekt, zoals sociale media.',
            p2: 'Ook gebruiken we je werkveld om je een betere ervaring op onze websites te geven.',
            p3: 'De gegevens die je met ons deelt, zijn altijd in veilige handen.',
            button: "Ik snap 'm",
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Voeg anderen toe aan je workspace',
      workspace: 'Workspace',
      manage_workspace: 'Workspace beheren',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, er is iets misgegaan. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    complete_payment_exception:
      'Hmm, er is iets mis gegaan. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com" rel="external">helpcentrum</a>',
    retrieve_checkout_exception:
      'Hmm, er is iets misgegaan. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    source_id_error:
      'Sorry, we konden je verzoek niet verwerken. Probeer het nog eens.',
    three_d_secure:
      'Wij bieden momenteel geen ondersteuning voor 3D Secure-kaarten.',
    something_went_wrong:
      'Hmm, er is iets mis gegaan. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    signin_no_data_exception:
      'Hmm, er is iets mis gegaan. Controleer je gebruikersnaam en wachtwoord en probeer het nog een keer.',
    signin_exception:
      'Sorry, maar we konden je niet inloggen. Probeer het nog een keer.',
    signout_exception:
      'Hmm, het lijkt erop dat we je niet kunnen uitloggen. Gek. Vernieuw de pagina om te controleren of je nog bent ingelogd.',
    signup_account_error:
      'Hmm, er ging iets mis met aanmelden. Controleer je gegevens en probeer het nog een keer.',
    retrieve_account_exception:
      'Hmm, er ging iets mis. Kun je het nog een keer proberen?',
    update_account_error:
      'Sorry, we konden je accountgegevens niet bijwerken. Zou je het nog een keer kunnen proberen?',
    retrieve_subscription_exception:
      'We konden je betaalgegevens niet vinden. Probeer het nog een keer.',
    update_subscription_exception:
      'We konden je betaalgegevens niet bijwerken. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com"><a href="https://wetransfer.zendesk.com">helpcenter</a>.',
    autorenewal_not_supported:
      'Automatische verlenging wordt niet ondersteund voor dit account',
    email_background_upload_validation_error:
      'Het bestand is te groot, of het is geen jpg of png. Upload een ander bestand.',
    email_background_upload_validation_error_videos:
      'Het bestand is te groot, of het is geen jpg of png. Upload een ander bestand.',
    update_password_exception:
      'Sorry, we konden je wachtwoord niet bijwerken. Probeer het nog een keer.',
    retrieve_device_exception:
      'We konden geen verbonden apparaten vinden. Probeer het nog een keer.',
    remove_device_exception: 'We konden dit apparaat niet verwijderen',
    renew_subscription_exception:
      'We konden je account niet verlengen. Probeer het nog een keer.',
    invoices_retrieve_exception:
      'We konden je facturen niet vinden. Probeer het nog een keer.',
    invoice_download_exception:
      'We konden deze factuur niet downloaden. Probeer het nog een keer.',
    image_not_valid: 'Hmm, het lukt niet om deze afbeelding te uploaden',
    update_profile_error:
      'Hmm, we konden je profiel niet bijwerken. Probeer het nog een keer.',
    retrieve_profile_exception:
      'We konden je profielinstellingen niet vinden. Probeer het nog een keer.',
    s3_exception:
      'Hmm, er ging iets mis tijdens het uploaden. Probeer het nog een keer.',
    file_size_limit_reached: 'Upload een afbeelding van maximaal 3MB',
    retrieve_transferlist_exception:
      'We konden je transferoverzicht niet vinden',
    retrieve_transfer_exception: 'We konden je transfergegevens niet vinden',
    delete_transfer_exception: 'We konden deze transfer niet verwijderen',
    delete_transfers_exception: 'We konden deze transfers niet verwijderen',
    update_expiry_exception: 'We konden deze verloopdatum niet aanpassen',
    add_contact_exception: 'We konden dit contact niet toevoegen',
    complete_last_order_exception: 'We konden je bestelling niet voltooien',
    edit_contact_exception: 'We konden dit contact niet bijwerken',
    remove_contact_exception: 'We konden dit contact niet verwijderen',
    request_password_reset_exception:
      'Sorry, we konden het verzoek niet verwerken. Probeer het nog een keer.',
    request_password_reset_no_user:
      'We herkennen dit e-mailadres niet. Controleer en probeer het nog een keer.',
    reset_password_error:
      'Er ging iets mis met instellen van je wachtwoord. Probeer het nog een keer.',
    reset_password_exception:
      'Sorry, we kunnen je wachtwoord niet opnieuw instellen. Probeer het nog een keer.',
    reset_password_token_invalid:
      'Hmm, deze link werkt niet. Volg de instructies die we je hebben gemaild of begin opnieuw.',
    retrieve_last_order_exception: 'We konden je bestelling niet vinden',
    retrieve_ternot_exception:
      'Hmm, we kunnen je transfer niet vinden. Probeer het nog een keer.',
    signin_invalid_credentials:
      'Dit e-mailadres en wachtwoord komen niet overeen. Controleer en probeer het nog een keer.',
    unsubscribe_expiration_exception:
      'Er ging iets mis met afmelden. Probeer het nog een keer.',
    unsubscribe_expiration_invalid_signature:
      'Hmm, deze link lijkt niet te werken. Probeer het nog een keer.',
    cancel_subscription_exception:
      'Er ging iets niet helemaal goed en we konden je abonnement niet stopzetten. Probeer het later opnieuw.',
    payment_cancelled:
      'Hmm, er is iets mis gegaan. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    profile_picture_upload_validation_error:
      'Het bestand is te groot, of het is geen jpg of png. Upload een ander bestand.',
    reactivate_subscription_exception:
      'Er is iets misgegaan, probeer het nog een keer',
    retrieve_contactlist_exception: 'We konden je contactenlijst niet vinden',
    source_retrieve_error:
      'Hmm, er is iets mis gegaan. Probeer het nog een keer of neem contact op met ons <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    token_error:
      'Er ging helaas iets mis. Misschien kun je het nog eens proberen?',
    update_user_error:
      'Er is een probleem opgetreden tijdens het updaten van je gegevens',
    wallpaper_upload_validation_error:
      'Het bestand is te groot, of het is geen jpg of png. Upload een ander bestand.',
    wallpaper_upload_validation_error_videos:
      'Oeps, je video voldoet niet aan de eisen — probeer het nog eens',
    declined_contact_bank_error:
      'Sorry, we konden deze betaling niet verwerken. Neem alsjeblieft contact op met je bank',
    invalid_password: 'Wachtwoord niet herkend',
    otp_token_invalid: 'Oeps, die code is verkeerd of verlopen',
    projects_load_exception: 'We kunnen je projecten momenteel niet laden',
    update_information_throttle:
      'Er is een probleem opgetreden tijdens het updaten van je gegevens. Neem even %{throttle_time} pauze voordat je het opnieuw probeert.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Producten',
        plans_and_pricing: 'Abonnementen en prijzen',
        pricing: 'Prijzen',
        pro_and_premium: 'WeTransfer Pro en Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Adverteren',
        upgrade: 'Upgraden',
      },
      name_1_2019: 'Bedrijf',
      name: 'Bedrijf',
    },
    home: {
      name: 'Home',
    },
    help: {
      name: 'Hulp',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transfers',
        contacts: 'Contacten',
        profile: 'Profile',
        account: 'Account',
        received: 'Ontvangen',
        sent: 'Verstuurd',
        teams: 'Team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Uitloggen',
    signin: {
      name: 'Log in',
    },
    branding: 'Branding',
    label: {
      beta: 'Bèta',
      new: 'Nieuw',
    },
    login: 'Inloggen',
    logout: 'Uitloggen',
    portals: 'Portals',
    signup: 'Aanmelden',
    features: {
      name: 'Functionaliteiten',
      all: 'Alle functies',
      file_sharing: 'Voor het delen van bestanden',
      collaboration: 'Voor samenwerking',
      security: 'Voor gegevensbeveiliging',
      branding: 'Voor branding',
      fast_feedback: 'Voor snelle feedback',
    },
    referral: 'Aanbevelen',
    switcher: {
      create_free_account: 'Voeg gratis toe',
      just_you: 'Alleen jij',
      team: 'Teamleden',
      team_member_count: '%{amountOfMembers} leden',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, je bent niet verbonden bent met het internet',
        begins_space:
          'We kunnen geen bestanden sturen waarvan de naam begint met een spatie. Geef je bestand een nieuwe naam en probeer het nog een keer.',
        begins_stop:
          'We kunnen geen bestanden sturen waarvan de bestandsnaam begint met punt. Geef je bestand een nieuwe naam en probeer het nog een keer.',
        blocked:
          'We konden WeTransfer niet laden - het lijkt erop dat je bent geblokkeerd',
        generic: 'Sorry, er ging iets mis met je transfer',
        has_blackslash:
          'We kunnen geen bestanden sturen met in de bestandsnaam een backslash. Geef je bestand een nieuwe naam en probeer het nog een keer.',
        has_linebreak:
          'We kunnen geen bestanden sturen met een regeleinde in de bestandsnaam. Geef je bestand een nieuwe naam en probeer het nog een keer.',
        incorrect_recipient:
          'Het lijkt erop dat een van de e-mailadressen die je hebt ingevuld niet juist is',
        incorrect_sender:
          'Het lijkt erop dat er een probleem is met je e-mailadres',
        io_error: 'Er is een probleem met je bestanden',
        long_filename:
          'We kunnen geen bestanden sturen met een bestandsnaam van meer dan 250 tekens. Geef je bestand een nieuwe naam en probeer het nog een keer.',
        long_message: 'Het bericht is wat te lang - probeer het in te korten',
        missing_default_recipient:
          'Je kunt alleen meer dan %{free_transfer_limit} sturen naar het geregistreerde WeTransfer Pro-mailadres. Vernieuw de pagina om nog een keer te beginnen.',
        no_clipboard: 'Het lijkt erop dat je de link niet hebt gekopieerd',
        no_files: 'Het lijkt erop dat je nog geen bestanden hebt toegevoegd',
        no_folders:
          'Je moet je bestand zippen/comprimeren voor we het kunnen sturen',
        no_recipient:
          'We hebben het e-mailadres nodig waar je deze bestanden naartoe wilt sturen',
        no_sender:
          'We hebben nu alleen nog je e-mailadres nodig en we kunnen aan de slag',
        too_big:
          'Helaas, we kunnen niet meer dan %{upload_limit} per keer uploaden',
        too_many_recipient:
          'Oeps! %{count} personen is de limiet. Naar meer mensen sturen? Gebruik een link transfer.',
        unavailable:
          'Sorry, deze transfer is verwijderd en niet meer beschikbaar',
        wrong_password:
          'Hmm, dat wachtwoord klopt niet. Probeer het nog een keer of controleer het bij de persoon die jou deze transfer heeft gestuurd.',
        default_title: 'Oeps!',
        duplicate_filename:
          'We kunnen niet meerdere bestanden met dezelfde naam versturen. Geef de bestanden een nieuwe naam en probeer het nog een keer.',
        firstaccept: 'Je moet akkoord gaan voordat je kunt verzenden',
        not_downloadable:
          'Hmm, er ging iets mis tijdens het ophalen van je bestanden. Vernieuw de pagina en probeer het opnieuw.',
        recaptcha: {
          text: 'Er is iets misgegaan. Probeer het opnieuw!',
          title: 'Oeps...',
        },
        too_big_text:
          'Je kunt maximaal %{upload_limit} per keer versturen. Verstuur tot %{plus_limit} met Pro. ',
        too_big_title: 'Hé grootverzender',
        too_many_files:
          'Je kunt maximaal %{count} bestanden tegelijkertijd versturen',
        too_many_recipient_text:
          'Met Pro verzend je bestanden naar maximaal 50 mensen.',
        too_many_recipient_title: 'Dat zijn te veel mensen',
        unavailable_forward:
          'Het lijkt erop dat je transfer is verwijderd en dus niet doorgestuurd kan worden',
        verify: {
          button: 'Nieuwe code graag!',
          text: 'Probeer het opnieuw of vraag een nieuwe code aan. ',
          title: 'Oeps!',
        },
      },
      buttons: {
        check_out: 'Aan de slag!',
        help: 'Helpcenter',
        plus: 'Upgraden',
        get_link: 'Link ophalen',
      },
      tips: {
        change_type:
          'Stuur bestanden via e-mail of maak een toegewezen transferlink aan die je kunt delen zoals je wilt',
        contacts:
          'Deze e-mailaddressen worden ook automatisch toegevoegd aan je contacten',
        expiry:
          'Met WeTransfer Pro bepaal jij wanneer je transfers verlopen. (Je kunt de verloopdatum zelfs aanpassen nadat je een transfer hebt verstuurd!)',
        free_limit:
          'Goed nieuws - je kunt tot %{size} per keer versturen. Nog beter nieuws - je kunt de service zo vaak gebruiken als je wilt!',
        message: 'Eventueel kun je hier een bericht toevoegen',
        password:
          'Je kunt je transfers beveiligen met een wachtwoord. We voegen dit wachtwoord niet toe aan de e-mail, dus je moet hem wel aan de juiste mensen geven!',
        recipient_limit:
          'Voeg tot %{email_limit} e-mailadressen toe of open het menu naast de transferknop om een link aan te maken',
        transfer_history: 'Je transfer is opgeslagen in het transferoverzicht',
        your_email:
          'Laat je eigen e-mailadres hier achter en we laten je weten wanneer de bestanden zijn gedownload',
        link_transfer:
          'Wist je dat je hier een link naar je transfer kunt vinden?',
        previews_receiver:
          'Je kunt een preview bekijken van afbeeldingen van Pro-gebruikers voordat je ze downloadt. Klik op een bestand om de inhoud te bekijken!',
        previews_sender:
          'Nu kun je een preview van afbeeldingen bekijken voordat je ze downloadt',
        vrl_text:
          'Nu kun je je bestanden bekijken zonder ze te hoeven downloaden.',
        vrl_title: 'Preview je bestanden',
        zip_text: "Verstuur je een map? Wij zippen 'm voor je",
        zip_title: 'Zippen niet nodig',
        add_display_name_tooltip:
          'Geef je transfer een titel zodat mensen weten wat de inhoud van je bestanden is. Zo kan je deze later ook makkelijker terugvinden.',
        anonymous_sender: {
          button: 'Creëer mijn link',
          text: 'Vul je e-mailadres hier in, dan krijg je van ons een seintje als je bestanden gedownload zijn.\n\nVerifieer je e-mailadres zodat we zeker weten dat jij het bent. Wil je niet elke keer verifiëren?',
          text_locked_recipient:
            'Vul je e-mailadres hier in, dan krijg je van ons een seintje als je bestanden gedownload zijn.\n\nVerifieer je e-mailadres zodat we zeker weten dat jij het bent.',
        },
        prefer_link: {
          button: 'Creëer mijn link',
          text: 'Wil je je e-mailadres liever niet verifiëren? Geen probleem.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Meer informatie',
        previews_sender_learnmore: 'Meer informatie',
      },
      recipient_locked_text:
        'Op deze pagina kan de eigenaar bestanden ontvangen. Log in als jij dat bent, of ga naar <a href="https://wetransfer.com">wetransfer.com</a> om bestanden te versturen.',
      recipient_locked_title: 'Opgelet',
      title: {
        previews_receiver: 'Previews van afbeeldingen',
        previews_sender: 'Previews van afbeeldingen',
      },
    },
    download: {
      blocked: {
        link: 'Meer informatie',
        text: 'Deze transfer is gerapporteerd en kan niet worden gedownload',
        title: 'Transfer geblokkeerd',
      },
      title: 'Wij zijn er klaar voor',
      expires: 'Transfer verloopt over %{relative_time}',
      expires_never: 'Geen verloopdatum',
      files: '%{count} bestanden, %{size}',
      format: '%{files}・%{expires}',
      expand: 'meer',
      download_link: 'Downloadlink',
      files_nosize: {
        one: '%{count} bestand',
        other: '%{count} bestanden',
      },
      show_all_files_mobile: 'Alle bestanden weergeven',
      zip_information:
        'Als je alle bestanden in één keer download, ontvang je een .zip-bestand - <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">meer info</a>',
      files_label: 'Files',
      message: 'Bericht',
      learn_more: 'meer informatie',
      expires_in: 'Vervalt over %{expiry}',
      download_all_zip:
        "Met 'Alles downloaden' worden alle bestanden als een .zip gedownload",
      back_to_transfer: 'Terug naar transfer',
      cookie_text:
        'We gebruiken cookies om je de beste ervaring te bieden. Geen zorgen, we verkopen je gegevens niet aan derden. Beheer je <a href="https://wetransfer.com/legal/manage-cookies" rel="external">gegevensvoorkeuren</a>.',
    },
    preview: {
      open_grid: 'Bekijk',
      click_to_open: 'Klik voor preview',
      grid: 'Items in deze transfer',
      link: 'Website',
      not_previewable: 'Geen preview',
      now_open: 'Preview geopend',
      open_link: 'Link openen in nieuw tabblad',
      open_link_short: 'Link openen',
      overview: 'het overzicht',
      reload: 'Klik hier om de pagina opnieuw te laden',
      something_went_wrong: 'Oeps, er is iets misgegaan',
      tap_to_open: 'Tik voor preview',
      toobig_copy:
        'Previews zijn beschikbaar voor afbeeldingen tot 50 MB. <a href="https://wetransfer.zendesk.com/" rel="external">Hier lees je er meer over</a>',
      toobig_title: 'Oef, deze afbeelding is te groot voor een preview',
      unsupported_copy:
        'In <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">dit artikel</a> lees je van welke bestanden we een preview kunnen weergeven',
      unsupported_title: 'Preview van dit bestand is (nog) niet mogelijk',
      visit_website: 'Naar website',
    },
    complete_mobile: {
      email_text:
        'We hebben je een transfermail gestuurd: je transfer blijft %{expires} beschikbaar',
      link_text: 'Kopieer je downloadlink:',
      email_text_no_expiry: 'Er is een e-mail naar de ontvanger gestuurd.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Wist je dat 30% van onze advertentieruimte naar kunstenaars gaat?</b> Door onze cookies te accepteren, zie je kunst, organisaties die we belangrijk vinden, en zo nu en dan bekroonde advertenties die je niet in de weg zitten. ',
          text: 'Geef je ook toestemming voor cookies van onze externe advertentiepartners zodat we de advertenties die je ziet kunnen personaliseren? ',
          title: 'Onze cookies voeden cultuur',
        },
        subtitle:
          '<b>Daarom gaat 30% van onze advertentieruimte naar kunstenaars.</b> Door onze cookies te accepteren, zie je kunst, organisaties die we belangrijk vinden, en zo nu en dan bekroonde advertenties die je niet in de weg zitten. ',
        text: 'Onze website gebruikt cookies om goed te kunnen functioneren, om ons te helpen begrijpen hoe jij WeTransfer gebruikt en om de prestaties te verbeteren. Geef je ook toestemming voor cookies van onze externe advertentiepartners zodat we de advertenties die je ziet kunnen personaliseren?',
        title: 'Wij geloven dat kunst bergen kan verzetten',
        'title-small': 'Welkom bij WeTransfer',
      },
      'button-accept': 'Ik ga akkoord',
      'button-accept-all': 'Alles accepteren',
      'button-ccpa': 'Afmelden voor de verkoop van persoonlijke gegevens',
      'button-cookies-privacy': 'Je privacykeuzes',
      'button-reject': 'Nee, bedankt',
      'button-save': 'Opslaan',
      'button-save-and-exit': 'Opslaan en sluiten',
      'ccpa-banner-text':
        'We gebruiken cookies om ervoor te zorgen dat je een topervaring hebt op onze website. Geen zorgen — we verkopen je gegevens niet aan derden. Wil je je hier toch voor afmelden? <a href="%{href}">Instellingen beheren</a>',
      'ccpa-body':
        'Omdat je in de VS woont, worden je rechten beschermd door de California Consumer Privacy Act (CCPA) en kun je ons vragen te stoppen met de verkoop van je persoonlijke gegevens. Dit betekent niet dat wij je persoonlijke gegevens of privé-bestanden aan de hoogste bieder verkopen — dat hebben we nooit gedaan en dat zullen we ook nooit doen! We doen ons uiterste best om jouw digitale voetafdruk klein, veilig en beheerbaar te houden. Bij <a href="%{href}">Je privacykeuzes</a> vind je meer informatie over welke gegevens wij verzamelen en waarom we dat doen.',
      'ccpa-donotsell':
        'Ik wil niet dat jullie mijn persoonlijke gegevens verkopen',
      'ccpa-header': 'Afmelden voor de verkoop van persoonlijke gegevens',
      'ccpa-intro':
        'Wij zijn een verantwoordelijk techbedrijf dat zich inzet voor een beter internet en daarom verkopen wij je gegevens niet aan anderen. Je hebt natuurlijk wel het recht om je hier officieel voor af te melden.',
      'ccpa-variant-test-text':
        'We gebruiken cookies om ervoor te zorgen dat je een naadloze ervaring hebt op onze website en om de advertenties die je ziet te personaliseren. <a href="%{href}">Cookies beheren</a>',
      headline: 'Cookies en advertenties',
      intro:
        'We gebruiken het geld dat we verdienen met onze prachtige advertenties om onze rekeningen te betalen. Zo kunnen we onze filesharingdienst gratis blijven aanbieden.',
      'manage-cookies': 'Cookies beheren',
      'partners-consent': 'Toestemming',
      'partners-features': 'Functionaliteiten',
      'partners-headline': 'Onze partners',
      'partners-text':
        '<p>Dit is een alfabetische lijst van de zorgvuldig gekozen partners die we toestemming geven om jouw data te verzamelen zodat we prestaties kunnen bijhouden en verbeteren.</p>',
      'preferences-headline': 'Cookies beheren ',
      'preferences-text':
        '<p>We respecteren jouw recht op privacy en de keuzes die je maakt met betrekking tot je data. We moeten een deel van je persoonlijke informatie verwerken wanneer je onze diensten gebruikt, maar zetten ons altijd in om op een verantwoorde en waardengedreven manier om te gaan met ons bedrijf, met tech, en met jou.</p>\n<p>Daarom doen we ons uiterste best om jouw digitale voetafdruk klein, veilig en beheerbaar te houden.</p>\n<p>We verzamelen en verwerken standaard alleen maar data wanneer dat strikt noodzakelijk is. Maar als je onze diensten wil steunen en WeTransfer gratis wil houden, help ons dan door toestemming te geven om informatie te delen met onze advertentiepartners.</p>',
      'preferences-text-allow-cookies':
        'Sta cookies toe zodat wij en/of onze partners:<br><br>',
      'purpose-description-first-intro':
        'Om producten te promoten op of buiten onze website en apps kan WeTransfer: ',
      'purpose-description-first-list':
        "<ul><li>Informatie verzamelen over hoe je onze website(s) gebruikt, zoals klikgedrag en bezochte pagina's, en (waar mogelijk) deze informatie combineren met data die we over jou hebben opgeslagen, zoals het e-mailadres van je account</li><li> De informatie die we verzamelen gebruiken om je aanbiedingen te doen via e-mail, op onze eigen website(s) of apps, en op websites of apps van derden. Het kan bijvoorbeeld dat we een van onze andere producten bij je aanprijzen als je al WeTransfer Pro gebruikt. </li></ul>",
      'purpose-description-second-intro':
        'Om producten te promoten op of buiten onze website en apps, kunnen onze partners: ',
      'purpose-description-second-list':
        "<ul><li>Informatie verzamelen over hoe je onze website(s) gebruikt, zoals klikgedrag en bezochte pagina's, en (waar mogelijk) deze informatie combineren met data die ze over jou hebben opgeslagen.</li><li>De informatie die ze over je verzamelen gebruiken om je aanbiedingen te doen via e-mail, op hun eigen website(s) of apps, en op websites of apps van derden waar zij mee werken.</li></ul>",
      'purpose-title':
        'Producten kunnen promoten op of buiten onze website en apps',
      'switch-by-partners': 'Door partners',
      'switch-by-we-transfer': 'Door WeTransfer',
      text: '<p> Onze website gebruikt <a href="%{href}">cookies</a> die ervoor zorgen dat de site goed functioneert, dat wij kunnen analyseren hoe je onze site gebruikt, en dat we de prestaties kunnen verbeteren.</p>\n<p>Wil je ook cookies toestaan van onze advertentiepartners zodat we je gepersonaliseerde advertenties kunnen laten zien en de producten van WeTransfer en onze partners kunnen promoten op en buiten onze websites en apps?</p>',
      'text-panel':
        '<p> Onze website gebruikt cookies die ervoor zorgen dat de site goed functioneert, dat wij kunnen analyseren hoe je onze site gebruikt, en dat we de prestaties kunnen verbeteren.</p>\n<p>Wil je ook cookies toestaan van onze advertentiepartners zodat we je gepersonaliseerde advertenties kunnen laten zien en de producten van WeTransfer en onze partners kunnen promoten op en buiten onze websites en apps?</p>',
      'tos-experiment': {
        'cookie-intro':
          'De eenvoudigste manier om grote bestanden te versturen terwijl je geweldige kunst en bekroonde advertenties ontdekt.',
        'cookie-text':
          "Onze website gebruikt cookies om goed te kunnen functioneren, om ons te helpen analyseren hoe jij de site gebruikt en om de prestaties te verbeteren. \nDoor onze cookies te accepteren, kunnen we je gepersonaliseerde advertenties laten zien. Hebben we het woord 'cookies' nu vaak genoeg gezegd? (Cookies.)",
      },
      trees: {
        'short-v': {
          subtitle:
            'Het is onze missie om de wereld mooier te maken met prijswinnende advertenties die je niet in de weg zitten en die ons helpen bij te dragen aan het herstel van zeebossen.',
          title: 'Onze cookies beschermen de planeet',
        },
        subtitle:
          'Door onze cookies te accepteren, help je ons direct om nog meer te doen voor de planeet. Alleen dit jaar al heeft WeTransfer beloofd meer dan 175.000 bomen te planten, en dat is nog maar het begin. Jij kunt een positieve impact maken, gewoon door onze bekroonde advertenties te ervaren. ',
        text: 'Onze website gebruikt cookies om de prestaties en service te verbeteren, en om jouw behoeften beter te begrijpen. Door onze cookies van derden te accepteren, kunnen wij en onze partners je relevantere advertenties aanbieden op en buiten onze website(s) en apps.',
        title: 'Verstuur ideeën. <b> Verander de wereld.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Activeer Collect Pro',
      title: 'Bewaar en deel alles wat je inspireert',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Vertel me meer',
      title: 'Paste® Pro en Collect Pro vanaf nu gratis bij jouw abonnement',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Activeer Paste® Pro',
      title: 'Maak van een goed idee een geweldige presentatie',
    },
    terms_conditions: {
      experiment: {
        text: 'Accepteer onze <a href="/legal/terms" data-route-type="plus">Servicevoorwaarden</a> om verder te gaan.',
        title: "Je bent er <span class='tc-title-exp'>bijna</span>",
        ustitle:
          "Welkom bij de eenvoudigste manier om <span class='tc-title-exp'>grote bestanden te versturen.</span>",
      },
      title: 'Eerst even dit...',
      text: 'We vragen je akkoord te gaan met onze <a href="/legal/terms" data-route-type="plus">Servicevoorwaarden</a> en ons <a href="/legal/privacy" data-route-type="plus">Cookiebeleid</a>. We gebruiken cookies voor functionele en analytische doeleinden, en cookies van derden voor reclamedoeleinden.',
      language: 'Je taal staat ingesteld op',
      button: 'Ik ga akkoord',
    },
    upsell_pricing: {
      text: 'Abonnementen vergelijken',
      title: 'Wil je grotere transfers versturen?',
      receiving: {
        title: 'Wil je alles uit WeTransfer halen?',
      },
    },
    welcome: {
      card1:
        'Verstuur en ontvang transfers tot %{transfer_limit} met één <strong>gedeeld overzicht</strong>',
      card2:
        "Lever werk aan vanaf jouw team's <strong>custom WeTransfer-pagina</strong>",
      card3:
        'Werk samen in <strong>Paste®</strong> aan decks en maak <strong>boards</strong> in Collect',
      cta: 'Aan de slag',
      headline: 'Je zit in het team, <strong>%{first_name}!</strong>',
      'opt-in':
        'Ik wil verhalen over creativiteit en het laatste WeTransfer-nieuws ontvangen',
    },
    form: {
      num_files: {
        one: '%{count} bestand · %{remaining} resterend',
        other: '%{count} bestanden · %{remaining} resterend',
      },
      add_files: 'Upload bestanden',
      more_files: 'Meer bestanden toevoegen',
      available_space: 'Voeg tot %{size} toe',
      message: 'Bericht',
      from: 'Je e-mailadres',
      to: 'Email naar',
      other_recipients: {
        one: '+%{count}',
        other: '+%{count}',
      },
      reset_forward: 'Doorsturen annuleren',
      drop_files: 'of sleep je bestanden hierheen',
      files_count: {
        one: '%{count} bestand toegevoegd · %{fileSize} in totaal',
        other: '%{count} bestanden toegevoegd · %{fileSize} in totaal',
      },
      select_folder: 'Of selecteer een map',
    },
    progress: {
      title: 'Bezig met transfer...',
      title_cancel: 'Deze transfer annuleren?',
      uploaded: '%{sent} van %{total} geüpload',
      remaining: {
        minutes: {
          zero: 'Minder dan 1 minuut resterend',
          one: 'Ongeveer 1 minuut resterend',
          other: 'Ongeveer %{count} minuten resterend',
        },
        hours: {
          one: 'Ongeveer 1 uur resterend',
          other: 'Ongeveer %{count} uur resterend',
        },
      },
      document_title: '%{percentage}% - Bezig met transfer...',
      meta: {
        email: {
          one_file_one_recipient:
            '%{filesCount} bestand versturen naar %{recipientsCount} persoon',
          one_file_other_recipients:
            '%{filesCount} bestand versturen naar %{recipientsCount} personen',
          other_files_one_recipient:
            '%{filesCount} bestanden versturen naar %{recipientsCount} persoon',
          other_files_other_recipients:
            '%{filesCount} bestanden versturen naar %{recipientsCount} personen',
        },
        link: {
          one: '%{count} bestand versturen',
          other: '%{count} bestanden versturen',
        },
      },
    },
    complete_link: {
      title: 'Je bent klaar!',
      text: 'Kopieer je downloadlink of <a href="/transfer/progress">bekijk de inhoud</a>.',
      text_copied: 'De link is naar je klembord gekopieerd',
      text_manual_copy:
        'Druk op %{shortcut} om de link naar je klembord te kopiëren',
      document_title: 'Klaar!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Je transfer is doorgestuurd',
    },
    complete_email: {
      title: 'Je bent klaar!',
      text: 'We hebben de transfermail verstuurd – je transfer blijft %{expires} beschikbaar. <a href="/transfer/progress">Bekijk de inhoud</a>',
      text_no_expiry:
        'De transfermail is verstuurd. <a href="/transfer/progress">Bekijk de inhoud</a>',
      document_title: 'Verstuurd!',
      text_no_details:
        'We hebben de transfermail verstuurd – je transfer blijft %{expires} beschikbaar.',
      team_discovery_title: 'Transfer verzonden!',
      team_discovery_text:
        'Je transfer is %{expires} beschikbaar om te downloaden',
    },
    failed: {
      title: 'Hmm, er ging iets mis',
      text: 'De transfer is niet verstuurd - probeer het nog een keer',
    },
    pending: {
      title: 'We zitten erbovenop',
      subtitle: 'Voorbereiden...',
    },
    downloading: {
      title: 'Bestanden verzamelen...',
      text: 'We zijn je download aan het voorbereiden',
    },
    downloaded: {
      title: 'Je download is begonnen',
      text: 'Zodra de download klaar is, staan de bestanden op je computer (meestal in de map voor downloads)',
      download_links:
        'Houd er rekening mee dat de links op dit Board niet worden weergegeven – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">hier lees je er meer over</a>.',
    },
    expired: {
      title: 'Transfer verlopen',
      text: 'Sorry, deze transfer is verlopen en niet meer beschikbaar',
    },
    password: {
      title: 'Wachtwoord invoeren',
      text: 'Je hebt een wachtwoord nodig om deze transfer te downloaden',
    },
    options: {
      transfer_type: 'Versturen als',
      password: 'Wachtwoord',
      password_placeholder: 'Wachtwoord instellen',
      expiry: 'Verloopt na',
      expire_in: {
        '1w': '1 week',
        '2w': '2 weken',
        '1m': '4 weken',
        never: 'Nooit',
        '14d': '2 weken',
        '28d': '4 weken',
        '365d': '1 jaar',
        '7d': '1 week',
        '90d': '3 maanden',
      },
      email: 'e-mail',
      link: 'link',
      email_transfer: 'Verstuur een e-mailtransfer',
      transfer_link: 'Transferlink ophalen',
    },
    buttons: {
      transfer: 'Versturen',
      forward: 'Doorsturen',
      new_transfer: 'Iets versturen?',
      cancel: 'Annuleren',
      cancel_no: 'Nee',
      cancel_yes: 'Ja',
      copy_link: 'Kopieer link',
      ok: 'Oké',
      done: 'Meer versturen?',
      team_discovery_done: 'Nieuwe transfer versturen',
      retry: 'Probeer opnieuw',
      continue: 'Verder',
      download: 'Downloaden',
      download_all: 'Alles downloaden',
      back_to_home: 'Terug naar home',
      cleanup: 'Bekijk transfers ',
      download_all_files: 'Download alle bestanden',
      help: 'Helpcenter',
      payment: 'Nu verlengen',
      complete_order: 'Naar betalen',
      download_all_experiment: 'Alles downloaden als .zip',
      download_experiment: 'Bestand downloaden',
      download_file: 'Bestand downloaden',
      download_zip: 'Alles downloaden als .zip',
      get_link: 'Link ophalen',
      go_to_transfer: 'Naar de transfer',
      openinapp: 'Opslaan met WeTransfer-app',
      openinapp_experiment: 'Opslaan met WeTransfer-app',
      openincollectapp: 'Opslaan met Collect app',
      get_a_link: 'Creëer mijn link',
    },
    account_expired: {
      text: 'Verleng nu je Pro account voordat het te laat is, of <a href="#signout">log uit</a> om terug te gaan naar de gratis service',
      title: 'Je Pro account is verlopen',
    },
    invalid: {
      text: 'We konden je bestanden niet vinden',
      title: 'Oeps...',
      link: 'Meer info',
    },
    outdated_browser: {
      text: 'WeTransfer ondersteunt veel verschillende webbrowsers, maar deze is wat te oud. Update je browser.',
      title: 'Je webbrowser is verouderd',
    },
    spam: {
      text: 'Deze transfer is gerapporteerd als spam en is verwijderd',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Increase limit',
      limit: 'Up to %{limit} free',
      remaining: '%{remaining} remaining',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Upgrade naar WeTransfer Pro',
      title: 'Transfers met een wachtwoord beveiligen - voor extra gemoedsrust',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Upgrade naar WeTransfer Pro',
      title: 'Een snellere, eenvoudigere manier om je transfers te beheren',
    },
    upsell_one: {
      bubble: {
        button: 'Upgrade',
        text: 'Beveilig je transfers met een wachtwoord en bepaal zelf wanneer ze verlopen.',
        title: 'WeTransfer Pro',
        text_experiment:
          'Met Pro stel je zelf wachtwoorden en verloopdata voor je transfers in.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer op Facebook',
      title: 'Het laatste nieuws van WeTransfer vind je ook op Facebook!',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Upgrade naar WeTransfer Pro',
      title: 'Personaliseer jouw transfers met een WeTransfer profiel',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Upgrade naar WeTransfer Pro',
      title: 'Kies voor groter, beter, sterker, sneller',
    },
    account_inactive: {
      text: 'Voltooi je registratie en ga aan de slag met Pro',
      title: 'Je account is\nnog niet actief',
      tiers: {
        text: 'Voltooi je betaling om aan de slag te gaan met %{plan}.',
        title: 'Je abonnement is nog niet actief',
      },
    },
    add_items: {
      files: 'Bestanden',
      folders: 'Mappen',
    },
    complete: {
      open_panel: '<a href="/transfer/progress"> Bekijk inhoud</a>?',
    },
    details: {
      button: {
        dismiss: 'Negeren',
      },
    },
    download_preview: 'Bestand downloaden',
    error: {
      expired: {
        link: 'Neem dan contact op met ons support-team.',
        text: 'Het lijkt erop dat je transfer verlopen is.\nKlopt dat niet?',
        title: 'Transfer verlopen',
      },
    },
    item: {
      details: {
        folder: 'Map',
      },
    },
    items: {
      zero: 'leeg',
      one: '%{count} item',
      other: '%{count} items',
    },
    mobile: {
      button: {
        back: 'Terug',
        cancel: 'Begin opnieuw',
        next: 'Volgende',
      },
      email: {
        title: 'Voeg e-mailadressen toe',
      },
      message: {
        placeholder: 'Voeg een bericht toe aan je transfer',
        title: 'Bericht',
      },
      options: {
        email: 'Een e-mail versturen',
        'email-description':
          'Verstuur je transfer met een simpele e-mail en we laten het je weten als deze gedownload is.',
        link: 'Creëer mijn link',
        'link-description':
          'Maak van je bestanden een link en deel deze zoals je zelf wilt.',
      },
    },
    recaptcha: {
      button: 'Ik ben een mens',
      text: 'We willen alleen nog even controleren of je geen robot bent',
      title: 'Je bent er bijna!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Help ons',
      title: 'Mogen we je iets vragen over hoe je werkt?',
    },
    'verification-code': 'Verificatiecode',
    verify: {
      button: 'Transfer starten',
      text: 'Kijk in je inbox en voer de verificatiecode hieronder in',
      title: "You've got mail!",
      'verification-code': 'Verificatiecode',
    },
    'account-verification-failed': {
      body: 'Het lukt ons niet om je e-mailadres te bevestigen. Stuur een nieuwe link om opnieuw te proberen.',
      cta: 'Nieuwe link sturen?',
      title: 'Er ging iets mis',
    },
    'cookie-banner': {
      'button-accept': 'Oké',
      'button-decline': 'Nee',
      text: 'Wij gebruiken <a href="%{href}">cookies</a> om de website goed te laten werken, deze te verbeteren, en om het gedrag van onze gebruikers te analyseren. Wil jij ook cookies van derden toestaan zodat je persoonlijke advertenties te zien krijgt?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Wij gebruiken analytische cookies zodat we kunnen begrijpen hoe je WeTransfer gebruikt. Hiermee kunnen we nieuwe functies A/B-testen, ervoor zorgen dat alles werkt zoals het hoort, en bots en kwaadaardige dingen, zoals spam, tegenhouden. Deze cookies kunnen cookies van derden omvatten die persoonsgegevens verwerken. ',
        title: 'Analytische cookies',
      },
      clear: {
        'clear-all-cookies': 'Alle cookies wissen',
        description:
          'Je kunt al je gegevens uit onze cookies verwijderen. Voor permanente verzoeken tot anonimiteit raden we je aan <a href="mailto:support@wetransfer.com">contact op te nemen met ons supportteam.</a>',
        title: 'Cookies wissen',
        warning:
          'Je wordt afgemeld bij WeTransfer als je je cookies hebt gewist. Dit heeft geen invloed op de transfers in je account.',
      },
      functional: {
        description:
          'Wij gebruiken functionele cookies om een naadloze ervaring te kunnen bieden op WeTransfer. Je moet ze accepteren om van onze service gebruik te kunnen maken.',
        title: 'Functionele cookies',
      },
      'not-yet-set':
        'Het lijkt erop dat we je cookievoorkeur nog niet weten. Sluit dit venster en stel je voorkeur in. Je kunt het hier later altijd nog wijzigen.',
      'save-and-reload': 'Instellingen opslaan',
      tracking: {
        description:
          "Wij gebruiken advertentiecookies op onze service, zodat we het succes van onze commerciële, redactionele en promotionele inspanningen kunnen meten. Er worden geen advertentiecookies geplaatst op pagina's die informatie verstrekken over ons merk en onze producten. Dankzij advertentiecookies kunnen we bijvoorbeeld registreren dat je op een bepaalde advertentie hebt geklikt. Als cookies van derden ook op andere domeinen en websites worden geplaatst, kunnen adverteerders je online gedrag volgen. WeTransfer heeft echter geen toegang tot de persoonsgegevens die worden verzameld. Daarom verwijzen we je naar het privacybeleid van de relevante derde partijen.",
        title: 'Advertentiecookies',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Oeps, er is iets misgegaan',
        'error-email-exists':
          'Oeps, het lijkt erop dat dit e-mailadres al in gebruik is',
        'throttle-error':
          'Wow, we hebben nu te veel e-mails naar je verstuurd. Wacht alsjeblieft %{throttle_time} voordat je een nieuwe code aanvraagt.',
      },
      back: 'Terug naar de verificatie van de code',
      body: 'Klopt het zo? Dit is het e-mailadres dat jij gebruikt voor WeTransfer.',
      email: 'E-mail',
      error: 'Oeps, er is iets misgegaan',
      'error-email-exists':
        'Oeps, het lijkt erop dat dit e-mailadres al in gebruik is',
      submit: 'Stuur opnieuw',
      'throttle-error':
        'Sorry, je hebt het te vaak geprobeerd. Start je transfer alsjeblieft opnieuw.',
      'throttle-error-action': 'Opnieuw beginnen',
      'throttle-error-link':
        'Wow, we hebben nu teveel e-mails naar je verstuurd. Wacht alsjeblieft %{throttle_time} voordat je een nieuwe e-mail aanvraagt.',
      title: 'Check je e-mail',
    },
    'email-verification-success': {
      body: 'Nu weten mensen zeker dat jouw transfers ook echt door jou zijn verstuurd.',
      free_signup: 'Gratis account aanmaken',
      onboarding_body:
        'High five, het is gelukt! Klaar om je eigen URL en wallpapers te kiezen?',
      onboarding_title: 'Welkom bij<br/>WeTransfer Pro!',
      send_files: 'Verstuur bestanden',
      start_onboarding: "Let's go",
      title: 'Je account is geverifieerd!',
      upsell: 'Wil je je e-mail niet elke keer verifiëren?',
      verified_sender_tooltip:
        'Je e-mailadres is geverifieerd. Mensen kunnen er dus op vertrouwen dat de transfers door jou zijn verzonden. Werk je <a href="%{href}">persoonlijke gegevens</a> bij om dit e-mailadres te wijzigen.',
      verified_sender_tooltip_icon:
        'Je hebt je e-mailadres geverifieerd. Anderen kunnen er nu op vertrouwen dat transfers door jou zijn verstuurd.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Oeps, die code is verkeerd of verlopen. Codes blijven na het versturen maar %{expiry_time} actief.',
        'error-expiry-time-action': 'Nieuwe code aanvragen',
        'throttle-error':
          'Je hebt te vaak een verkeerde of verlopen code ingevoerd. Wacht alsjeblieft %{throttle_time} voordat je een nieuwe code aanvraagt.',
      },
      back: 'Terug',
      body: 'We hebben een verificatiecode verstuurd naar <strong title="%{account_email}">%{account_email}</strong> om er zeker van te zijn dat jij het bent. (vergeet niet om je ongewenste berichten te controleren).',
      body_link:
        'Even checken of jij het écht bent. <br/><br/> We hebben een verificatielink gestuurd naar <strong title="%{account_email}"> %{account_email}</strong> (niets ontvangen? Check je spam).',
      error: 'Oeps, die code is verkeerd of verlopen',
      'error-expiry-time':
        'Oeps, die code is verkeerd of verlopen. Codes blijven na het versturen maar %{expiry_time} actief.',
      'error-expiry-time-action': 'Nieuwe code aanvragen',
      resend: 'Geen e-mail ontvangen?',
      submit: 'Verifieer',
      'throttle-error':
        'Sorry, je hebt het te vaak geprobeerd. Start je transfer alsjeblieft opnieuw.',
      'throttle-error-action': 'Opnieuw beginnen',
      title: 'Bevestig jouw e-mailadres',
      'verification-code': 'Vul de verificatiecode in',
    },
    'force-account-verification': {
      body: 'We sturen je een link waarmee je het e-mailadres dat je voor WeTransfer gebruikt kunt bevestigen.',
      cta: 'Stuur e-mail',
    },
    'marketing-email-prompt': {
      body: 'Nog één ding: wil je nieuws en productupdates van WeTransfer ontvangen?',
      skip: 'Nee, bedankt',
      subscribe: 'Ja, hou me op de hoogte',
      title: 'Je bent geverifieerd!',
    },
    'terms_conditions-no-cookies': {
      text: 'Wil je verder? Ga dan eerst akkoord met onze <a href="/legal/terms?from_home" data-route-type="plus">Servicevoorwaarden</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Ontvang je bestanden in de WeTransfer-app',
      ios_banner_prompt_send: 'Snel en eenvoudig bestanden verzenden',
      tnc_subtitle: 'De eenvoudigste manier om grote bestanden te verzenden',
    },
  },
  account: {
    legend: {
      plan: 'Abonnement',
      save: 'bespaar %{amount}%',
      subscription: 'Abonnementsvorm',
      summary: 'Overzicht van je bestelling',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Waarom moet ik mijn e-mailadres bevestigen?',
    workspace: {
      default_workspace: 'Werkruimte van %{name}',
      your_workspace: 'Jouw werkruimte',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Je privacykeuzes',
        subtitle: 'Beheer je gegevens',
        p1: 'We willen je altijd de beste ervaring bieden, zelfs als het gaat om onze advertenties.',
        p2: 'We willen graag gegevens die je deelt (zoals je e-mailadres) gebruiken om te begrijpen welk soort inhoud je het leukst vindt én om jou (en anderen zoals jij) WeTransfer-advertenties te laten zien die het meest zijn afgestemd op je behoeften.',
        p3: 'Alles wat je maakt en deelt met WeTransfer blijft privé: we lezen niet mee en gebruiken die inhoud niet voor reclamedoeleinden.',
        p4: 'Als je besluit om iets via ons te delen, blijft die informatie altijd in veilige handen.',
        control_label:
          'Laat WeTransfer de gegevens die je deelt (zoals je e-mailadres en vakgebied) gebruiken om afgestemde advertenties op onze websites en op andere websites weer te geven.',
      },
      vertical_nav: {
        terms_of_service: 'Servicevoorwaarden',
        privacy_and_cookie_statement: 'Privacy- en cookieverklaring',
        your_privacy_choices: 'Je privacykeuzes',
        notice_and_takedown_policy: 'Kennisgevings- en verwijderingsbeleid',
        responsible_disclosure_policy:
          'Beleid inzake verantwoorde openbaarmaking',
        advertising_terms_and_conditions:
          'Algemene voorwaarden voor advertenties',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Sluiten en naar bestanden verzenden',
  },
  account_start_screen: {
    'collect-description':
      'Bewaar al je inspiratie op één plek, of je nu op je telefoon, laptop of tablet zit.',
    'collect-title': 'Ga naar Collect',
    'paste-description':
      'Maak in een paar seconden prachtige slides met presentatiedecks die zichzelf ontwerpen.',
    'paste-title': 'Ga naar Paste®',
    title: 'Drie tools. Eén account. Eindeloze mogelijkheden.',
    'transfer-cta': "Ja, let's go",
    'transfer-description':
      'Maak een geweldige indruk elke keer als iemand je bestanden downloadt. Klaar om je eigen url en wallpapers te kiezen?',
    'transfer-title': 'Stel je eigen WeTransfer-pagina in',
  },
  account_welcome_screen: {
    'pro-title': '<strong>%{name}</strong>, welkom bij WeTransfer Pro!',
    accept: 'Ja, graag',
    'accept-short': 'Oké',
    body_1:
      'Wil je verhalen over creativiteit en het laatste WeTransfer-nieuws van ons ontvangen?',
    body_2: '(Je kunt je altijd weer afmelden.)',
    decline: 'Nee, bedankt',
    'decline-short': 'Nee, dank je',
    title: 'Welcome bij WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Cookies accepteren',
      deny: 'Cookies afwijzen',
      manage: 'Cookies beheren',
    },
    description:
      'Wij gebruiken gewone cookies en analytische cookies om je een goede ervaring te kunnen bieden, en cookies van derden voor reclamedoeleinden.',
    heading:
      'Maak kennis met de eenvoudigste manier om grote bestanden te versturen',
    snippet: 'Welkom bij WeTransfer',
  },
  dropzone: {
    pro: {
      title: '<span>Drop</span> hier<br>je bestanden',
    },
    title: 'Drop it like it’s hot',
    text: 'Upload bestanden of mappen door ze naar dit venster te slepen',
  },
  form: {
    account: {
      billing_address: 'Factuuradres',
      billing_cta: 'Naar betalen',
      billing_title: 'Factuurgegevens',
      legend: {
        details: 'Je gegevens',
        coupon_code: 'Voeg een kortingscode toe',
        free_plus: 'Meld je aan voor een gratis Pro account',
      },
      label: {
        year_label: 'per jaar',
        year_sublabel: 'Bespaar en ontvang %{discount_rate}% korting!',
        month_label: 'per maand',
        month_sublabel: 'Maandelijkse factuur',
        email: 'E-mailadres',
        not_required: '(optioneel)',
        current_password: 'Huidig wachtwoord',
        new_password: 'Nieuw wachtwoord',
        repeat_new_password: 'Bevestig nieuw wachtwoord',
        password: 'Wachtwoord',
        password_confirm: 'Bevestig wachtwoord',
        full_name: 'Voor- en achternaam',
        company: 'Bedrijf',
        street_and_number: 'Adres',
        city: 'Plaats',
        zipcode: 'Postcode',
        country_code: 'Land',
        vat_number: 'Btw',
        coupon_code: 'Kortingscode',
        family_name: 'Achternaam',
        given_name: 'Voornaam',
        state_code: 'Staat',
      },
      description: {
        password: 'Kies een wachtwoord dat minimaal 6 tekens bevat',
        vat_number:
          'We brengen bedrijven die in Nederland zijn gevestigd 21% btw in rekening. Als jouw bedrijf elders in Europa is gevestigd, voer dan je bedrijfsgegevens in en het Europese btw-ID, zodat de btw van de factuur kan worden afgehaald. \n\nAls je bedrijf buiten de Europese btw-regio is gevestigd, hebben we nog steeds je bedrijfsinformatie nodig, maar we brengen dan geen btw in rekening.',
      },
      error: {
        email: {
          blank: 'Vul je e-mailadres in',
          invalid: 'Vul een geldig e-mailadres in',
          taken: 'Dit e-mailadres is al in gebruik',
          taken_login:
            'Dit e-mailadres is al in gebruik <a class="form-notification__message-link" href="%{login_url}">Inloggen?</a>',
        },
        current_password: {
          invalid: 'Wachtwoord niet herkend',
          blank: 'Vul je huidige wachtwoord in',
        },
        password: {
          blank: 'Vul je nieuwe wachtwoord in',
          too_short: 'Kies een wachtwoord dat minimaal 6 tekens bevat',
        },
        password_confirm: {
          blank: 'Bevestig je nieuwe wachtwoord',
          confirm: 'Deze wachtwoorden komen niet overeen',
        },
        full_name: {
          blank: 'Vul je naam in',
          too_short: 'Oeps, je naam moet uit minstens 3 karakters bestaan',
        },
        street_and_number: {
          blank: 'Vul je adres in',
        },
        city: {
          blank: 'Vul je plaats in',
        },
        zipcode: {
          blank: 'Vul je postcode in',
        },
        country_code: {
          inclusion: 'Check je spelling, of probeer een ander land',
          blank: 'Vul je land in',
        },
        vat_number: {
          vat_number: 'Vul een geldig btw-nummer in',
        },
        terms_of_service: {
          accepted:
            'Je moet akkoord gaan met onze Servicevoorwaarden om verder te gaan',
        },
        no_results: 'Check je spelling, of probeer een ander land',
        convert: {
          expired:
            'Sorry, deze transfer is verlopen en kan niet meer bewaard worden. Wist je dat je met WeTransfer Pro je transfers zo lang als je wil kan bewaren? Lees hier meer.',
        },
        coupon_code: {
          coupon_code: 'Vul een geldige kortingscode in',
        },
        no_state_results: 'Is dat een staat?',
      },
      complete_order: 'Rond je bestelling af',
      terms_conditions:
        'Ik ga akkoord met de <a href="/legal/terms" %{options}>Servicevoorwaarden</a> en heb de <a href="/legal/privacy" %{options}>privacy- en cookieverklaring</a> gelezen',
      signup_for_plus: 'Meld je aan voor WeTransfer Pro',
      account_cta: "Let's go",
      signup_for_account: 'Maak een WeTransfer account',
      'email-verification-not-verified-link':
        'Verifieer je e-mailadres via de mail die we hebben verstuurd, of <button type="button" class="button button--link">vraag een nieuwe mail aan</button>.',
      'email-verification-resend': {
        error: 'Oeps, er is iets misgegaan',
        info: 'Nieuwe code verstuurd! Check je inbox',
        info_link: 'Er is een nieuwe e-mail verstuurd! Check je inbox.',
        'throttle-error':
          'Wow, we hebben nu teveel e-mails naar je verstuurd. Wacht alsjeblieft %{throttle_time} voordat je een nieuwe code aanvraagt.',
      },
      'force-account-verification': {
        message:
          'Verifieer je e-mailadres zodat we zeker weten dat jij het écht bent.',
      },
      marketing_opt_in: 'Ik ontvang graag nieuws en updates van WeTransfer.',
      sso: {
        header: 'Persoonlijke gegevens',
        password_reset: {
          button: 'Stuur e-mail',
          instructions:
            'Wil je eens wat anders (als wachtwoord)? Dat kan. Als je op de knop hieronder drukt, sturen we een e-mail naar <span>%{email}</span> met een link om je wachtwoord te wijzigen.',
          success: 'E-mail verstuurd! Check je inbox.',
          title: 'Wachtwoord wijzigen',
        },
        wrong_user: 'Ben jij dit niet? Uitloggen',
      },
    },
    payment_cancel: {
      submit: 'Bevestigen',
      client_request:
        'Een klant wilde dat ik WeTransfer gebruikte en nu heb ik het niet nodig',
      different_tool: 'Ik heb een andere dienst gevonden',
      extra_features: 'Ik mis bepaalde functies',
      not_enough_storage: 'Er is te weinig opslagruimte voor mij',
      not_often_large_files: 'Ik verstuur niet vaak genoeg grote bestanden',
      other: 'Anders',
      other_more: 'Kun je vertellen waarom?',
      skip: 'Sla over en zeg abonnement op',
      temp_project:
        'Ik hoefde alleen maar grote bestanden te versturen voor een tijdelijk project',
      too_expensive: 'Ik vind het te duur',
    },
    payment_cancel_reason: {
      skip: 'Ik wil geen feedback geven',
    },
    profile: {
      label: {
        profile_title: 'Naam',
        wallpaper_link: 'Link naar je persoonlijke- of bedrijfswebsite',
      },
      error: {
        subdomain_name: {
          too_short:
            'Less is more natuurlijk, maar helaas moet het persoonlijke deel van je WeTransfer-url uit minimaal twee tekens bestaan',
          domain_name: 'Sorry, iemand was je voor! Deze naam is al in gebruik.',
          invalid:
            'Dat wordt wat te gek. Je WeTransfer-url mag alleen letters en cijfers bevatten (eventueel met een streepje ertussen)',
          taken: 'Sorry, iemand was je voor! Deze naam is al in gebruik.',
        },
        subdomain: {
          too_short: 'Zorg dat je url tenminste uit 2 tekens bestaat',
          too_long: 'Zorg dat je minder dan 63 tekens gebruikt',
          invalid:
            'Oeps. Je WeTransfer-url mag alleen letters en cijfers bevatten (eventueel met een streepje ertussen)',
          domain_name: 'Deze url wordt al gebruikt',
        },
        default_recipient_email: {
          invalid: 'Vul een geldig e-mailadres in',
        },
        wallpaper_link: {
          invalid: 'Vul een geldig webadres in',
        },
      },
      success: {
        subdomain: {
          updated: 'Je url is bijgewerkt',
          available: 'Goed nieuws, deze url is nog beschikbaar',
        },
      },
      change_background: 'Afbeelding uploaden',
      delete_avatar: 'Verwijder profielfoto',
      delete_background: 'Afbeelding verwijderen',
      description: {
        title:
          'Gebruik maximaal 150 tekens zodat er niets buiten de pagina valt',
        wallpaper_link:
          'Als iemand op de wallpapers op jouw pagina klikt, wordt deze website geopend in een nieuw tabblad.',
        recipient_email_locked:
          'Bestanden die via je profiel verstuurd worden gaan alleen naar dit e-mailadres.',
      },
      upload_avatar: 'Upload profielfoto',
      use_email_background_checkbox_label:
        'Gebruik deze wallpaper voor alle transfers die worden verstuurd via mijn profiel',
      account_email_checkbox: 'E-mailadres tonen op profiel',
      default_recipient_email_info:
        'Ga naar je <a href="/account"> gegevens</a> om dit e-mailadres aan te passen',
      change_subdomain: {
        message:
          'Url wijzigen in <a href="%{url}">%{subdomain}.wetransfer.com</a>? Je oude url is dan meteen weer beschikbaar voor anderen.',
        confirm: 'Ja, url wijzigen',
        cancel: 'Terug',
      },
    },
    fill_in_password: 'Vul je wachtwoord in om deze wijzigingen op te slaan',
    select_all: 'Alles selecteren',
    deselect_all: 'Alles deselecteren',
    save_changes: 'Wijzigingen opslaan',
    save: 'Opslaan',
    submitting: 'Bezig met verwerken...',
    cancel: 'Annuleren',
    forward: 'Doorsturen',
    proceed: 'Verder',
    delete: 'Verwijderen',
    onboarding: {
      placeholder: {
        subdomain_name: 'kies-een-goede-naam',
      },
      validated: {
        subdomain_name: 'Goed nieuws, dit domein is nog beschikbaar',
      },
    },
    confirm_leave:
      'Deze pagina verlaten? Je wijzigingen worden dan niet opgeslagen.',
    unsaved_changes:
      'Pagina verlaten? Alle niet-opgeslagen wijzigingen gaan verloren.',
    contact: {
      add_contact: 'Voeg een contact toe',
      error: {
        email: {
          duplicate: 'Dit e-mailadres staat al in je contactenlijst',
          invalid: 'Vul een geldig e-mailadres in',
        },
      },
      label: {
        company: 'Bedrijf',
        email: 'E-mailadres',
        name: 'Naam',
      },
    },
    error: {
      current_password: {
        blank: 'Vul je huidige wachtwoord in',
        invalid: 'Wachtwoord niet herkend',
      },
      email: {
        blank: 'Vul je e-mailadres in',
        duplicate: 'Dit e-mailadres staat al in je contactenlijst',
        invalid: 'Vul een geldig e-mailadres in',
        taken: 'Dit e-mailadres is al in gebruik',
      },
    },
    leave: 'Verlaten',
    resetpassword: {
      button: {
        request_submit: 'Verstuur',
        reset_submit: 'Opslaan',
      },
      label: {
        confirm_new_password: 'Bevestig nieuw wachtwoord',
        email: 'E-mailadres',
        new_password: 'Nieuw wachtwoord',
      },
      legend: {
        request_description:
          'Kun je er niet meer in? We sturen je instructies om je wachtwoord opnieuw in te stellen zodat je weer verder kan.',
        request_title: 'Je wachtwoord vergeten?',
        reset_description:
          'Vul een nieuw wachtwoord om weer toegang te krijgen',
        reset_title: 'Stel een nieuw wachtwoord in',
        request_description_success_or_article:
          'Als je een WeTransfer account hebt, ontvang je per e-mail instructies om je wachtwoord te resetten. Als je binnen een paar minuten geen bericht hebt ontvangen, lees dan <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">hier</a> wat je moet doen.',
      },
    },
    signin: {
      button: {
        submit: 'Log in',
      },
      label: {
        email: 'E-mailadres',
        password: 'Wachtwoord',
        remember_me: 'Ingelogd blijven',
      },
      link: {
        forgot_password: 'Wachtwoord vergeten?',
      },
      title: 'Inloggen',
    },
    stay_on_page: 'Op pagina blijven',
    close_panel: 'Sluiten',
    go_back: 'Terug',
    labels: {
      email: 'E-mailadres',
    },
    plan: {
      change: {
        month: 'Maandelijks (%{currency}%{price})',
        title: 'Wijzig het abonnement',
        year: 'Jaarlijks (%{currency}%{price})',
      },
      change_plan: 'Betaalplan wijzigen',
      month: {
        copy: 'Maandelijkse factuur',
        label: 'Per maand',
        'label-payment': 'Betalen per maand',
        'sub-label': 'Elke maand een factuur',
        title: 'WeTransfer Pro: Maandelijkse betaling',
      },
      title: 'Geef je ideeën de ruimte die ze verdienen',
      year: {
        discount: 'Bespaar %{rate}% (yes!)',
        'label-payment': 'Betalen per jaar',
        'sub-label': 'Daarmee bespaar je 17%. Ka-ching',
        title: 'WeTransfer Pro: Jaarlijkse betaling',
      },
      your_order: 'Jouw bestelling',
    },
    save_and_continue: 'Opslaan en doorgaan',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Vul je wachtwoord in om verder te gaan',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Niet nu',
        true: 'Open in de WeTransfer-app',
      },
      headline: 'Waarom niet groter denken?',
      headline2: 'Bestanden bekijken in de app?',
      subheader: 'Verstuur én ontvang 200 GB met WeTransfer Pro',
      subheader2:
        'Bekijk bestanden voordat je ze downloadt. Verstuur en ontvang transfers, hou downloads bij en ontvang meldingen.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Verleng nu om te blijven profiteren van alle voordelen van je %{tier}-account',
      account_expired_title_tier: 'Je %{tier}-account is verlopen',
      account_inactive_title_tier: 'Klaar voor %{tier}',
      account_inactive_action: 'Ja, doorgaan',
      account_inactive_subtitle:
        'Nog één stap en dan ben je klaar. Van gedachten veranderd? Geen probleem—',
      account_inactive_title: 'Klaar om over te stappen op Pro?',
      account_subscription_action: 'Nu verlengen',
      account_subscription_expired: 'Je Pro account is verlopen',
      account_subscription_subtitle:
        'Verleng nu om je transfers, persoonlijke wallpaper en webadres te behouden. Let wel, deze worden anders binnenkort verwijderd.',
      account_expired_action: 'Nu verlengen',
      account_expired_subtitle:
        'Verleng nu je Pro account voordat het te laat is',
      account_expired_title: 'Je Pro account is verlopen',
      expired_transfer_subtitle:
        'De bestanden zijn niet meer beschikbaar. Je kunt de gegevens <a>hier</a> verwijderen uit je transferoverzicht.',
      expired_transfer_title: 'Deze transfer is verlopen',
      account_email_verify_logged_out: 'Log in om je e-mailadres te verifiëren',
      account_inactive_sublink: 'je bestelling annuleren.',
      email_unverified_mobile_cta: 'Klaar om te verifiëren',
      email_unverified_text:
        "We hebben een verificatiecode naar %{email} gestuurd. <a href='%{href}'> Ben jij dit niet?</a>",
      email_unverified_text_link:
        "We hebben een e-mail gestuurd naar %{email}. <a href='%{href}'>Ben jij dit niet?</a>",
      email_unverified_title: 'Verifieer je e-mailadres',
      'force-account-verification': {
        body: 'We sturen je een link om te checken of jij het écht bent.',
      },
      'receiving-email':
        'Let op! In je profiel hebben we %{receiving_email} een andere plek gegeven. Nieuwe transfers verschijnen nu alleen in je overzicht als ze zijn verstuurd naar %{account_email}. Wil je dit niet? Je kunt je <a href="/account"> gegevens</a> altijd aanpassen.',
    },
    design:
      'Je hebt vast gemerkt dat we het een en ander hebben veranderd. Om veel van die veranderingen is door jullie zelf gevraagd. Kijk dus snel naar onze nieuwe en - in onze ogen - verbeterde site en stuur ons je eventuele feedback.',
    loading_error:
      'Hmm, het lijkt erop dat deze pagina momenteel niet geladen kan worden. \nWe blijven het proberen, of <a href="%{path}">probeer</a> het zelf.',
    redesign_notice:
      'Je hebt vast gemerkt dat we het een en ander hebben <a href="/about/redesign">veranderd</a>. Om veel van die veranderingen is door jullie zelf gevraagd. Kijk dus snel naar de nieuwe en - in onze ogen - verbeterde site en <a href="/contact" rel="external">stuur ons</a> je eventuele feedback.',
    return_to: 'terug naar %{pageName}',
    close: 'Venster sluiten',
    cookie: {
      accept: 'Oké',
      text: 'Wij gebruiken cookies. <a href="/legal/terms">Hier lees je de juridische info.</a>',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Vacatures',
      press: 'Pers',
      terms: 'Voorwaarden',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Upgraden',
    free_limit:
      'Je kan niet meer dan 2 GB per keer versturen. Wil je grotere transfers sturen?',
    compare_plans: {
      button: 'Abonnementen vergelijken',
      text: 'Je kunt je abonnement upgraden om meer dan 2 GB tegelijk te versturen.',
      title: 'Moet je nog meer bestanden versturen?',
    },
    mobile: {
      cta: 'Meer weten',
      header: 'Profiteer van het beste van WeTransfer',
      upsell_enjoy: 'Krijg meer opslagruimte',
      upsell_one: 'Verstuur grotere transfers',
      upsell_two: 'Personaliseer je WeTransfer-pagina',
    },
    pro_limit:
      'Je kan niet meer dan 200 GB per keer versturen. Wil je transfers zonder limiet sturen?',
  },
  upsell_tiers_one: {
    text: 'Wil je wachtwoorden en vervaldatums instellen voor je transfers?',
  },
  upsell_tiers_three: {
    text: 'Wil je transfers versturen naar meer dan %{email_limit} e-mailadressen per keer?',
    title: 'Dat is er eentje te veel',
  },
  browser: {
    assets_failed: {
      text: 'We konden een paar belangrijke delen van de website niet laden. \nMisschien worden ze geblokkeerd door je firewall-, proxy- of browserinstellingen. \nVernieuw de pagina of neem contact op via ons <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>.',
      title: 'Oeps...',
    },
    javascript_needed:
      'Om WeTransfer te gebruiken heb je een browser nodig die JavaScript ondersteunt',
  },
  languages: {
    en: 'Engels',
    nl: 'Nederlands',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Deze aanbieding is geldig tot %{end_date}. De korting geldt voor het eerste jaar van%{user_tier}, waarna het abonnement wordt verlengd voor de volledige prijs van %{yearly_amount} per %{billing_period}.',
    },
    modal: {
      title: '%{discount_amount}% korting op een jaarabonnement op Pro',
      subtitle: 'Kortingscode: %{coupon_code_name}',
      text_content:
        'Dat is alles. Dat is de afspraak. We geven je %{discount_amount}% korting op een jaarabonnement op Pro.',
      argument: {
        size_limit: 'Verstuur en ontvang transfers tot 200 GB',
        storage_size: 'Profiteer van 1 TB opslagruimte',
        unlimited_review: 'Maak onbeperkte reviews',
      },
      cta_label: 'Korting claimen',
      dismiss_label: 'Niet nu',
    },
    banner: {
      title:
        'Ontvang een jaar lang %{discount_amount}% korting op WeTransfer Pro — onze beste deal ooit',
      cta_label: 'Upgraden',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Verstuur samen transfers met %{first_recipient_email}',
      subtitle:
        'Nodig je team uit om transfers te versturen en ontvangen met je %{user_plan}-abonnement.',
      list: {
        overview_item: 'Gedeeld overzicht van transfers',
        storage_limit_item:
          'Gedeelde opslag van %{storage_limit} extra per persoon',
        branding_item: 'Gedeelde teambranding',
        subscription_item: 'Gedeelde abonnementen en facturering',
      },
      cta: 'Team uitnodigen',
      dismiss_button: 'Vandaag nog niet',
    },
    second_viewing: {
      title: 'Verstuur samen transfers met ${first_recipient_email}',
      subtitle:
        'Nodig je team uit om transfers te versturen en ontvangen met je %{user_plan}-abonnement.',
      list: {
        overview_item: 'Gedeeld overzicht van transfers',
        storage_limit_item:
          'Gedeelde opslag van %{storage_limit} extra per persoon',
        branding_item: 'Gedeelde teambranding',
        subscription_item: 'Gedeelde abonnementen en facturering',
      },
      cta: 'Team uitnodigen',
      dismiss_button: 'Voor altijd verbergen',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Je account is bijgewerkt',
    update_password: 'Je wachtwoord is bijgewerkt',
    update_subscription: 'Je abonnement is bijgewerkt',
    update_profile_success: 'Je branding is bijgewerkt',
    link_copied: 'De link is naar je klembord gekopieerd',
    copy_link_manual: 'Link geselecteerd - kopieer met %{shortcut}',
    delete_transfer_success: 'Deze transfer is verwijderd',
    delete_transfers_success: 'Transfers zijn verwijderd',
    update_expiry_success: 'De verloopdatum is aangepast',
    onboarding_success:
      'Deze kant op voor je transferoverzicht, contacten, profielinstellingen en meer',
    add_contact_success: 'Het contact is toegevoegd',
    edit_contact_success: 'Het contact is bijgewerkt',
    remove_contact_success: 'Het contact is verwijderd',
    already_signed_in: 'Je bent nu ingelogd',
    cancel_subscription_success:
      'Jammer dat je gaat. Je abonnement is stopgezet.',
    collect_app_banner_desc:
      'Bekijk, bewaar en beheer bestanden via de Collect app',
    contact_added_confirmation: 'Contact was aan de transfer toegevoegd',
    contact_recipient_locked_text:
      'Op deze pagina kan de eigenaar bestanden ontvangen. Naar iemand anders versturen?',
    forward_ready: 'Je transfer staat klaar om doorgestuurd te worden',
    mobile_app_banner_desc: 'Bekijk, bewaar en beheer bestanden in de app',
    mobile_app_banner_title: 'Opslaan in de app',
    reactivate_subscription_success:
      'Welkom terug. Je account is weer actief. ',
    refresh_transfer_upload_lost:
      'Weet je zeker dat je de huidige upload wilt annuleren?',
    update_payment_success: 'Geslaagd! Je betaalgegevens zijn bijgewerkt.',
    update_user: 'Je gegevens zijn geüpdatet',
    current_team_notification: 'Je gebruikt nu %{plan} als %{currentTeam}',
    display_name_updated: 'Titel aangepast!',
    download_started:
      'Je download is begonnen. Zodra de download klaar is, staan de bestanden op je computer (meestal in de map voor downloads).',
    logged_out:
      'Het lijkt erop dat je in een andere browser bent uitgelogd. Log opnieuw in.',
    project_delete:
      '<strong><u>%{projectName}</u></strong> deleten en alle bestanden die je eraan hebt toegevoegd?',
    project_delete_success: '<strong>%{projectName}</strong> is gedeletet',
    password_changed: 'Wachtwoord gewijzigd',
    password_removed: 'Wachtwoord verwijderd',
  },
  alert: {
    confirm_cancel_upload_image:
      'Weet je zeker dat je de huidige upload wilt annuleren? ',
    cancel_recipient_locked: 'Annuleer',
    cancel_refresh_transfer_upload_lost: 'Nee',
    confirm_refresh_transfer_upload_lost: 'Ja',
    go_to_transfer: 'Naar de transfer',
    redirect_recipient_locked: 'Ja',
    stay: 'Op pagina blijven',
    cancel_project_delete: 'Annuleren',
    confirm_project_delete: 'Verwijderen',
  },
  force_update:
    'Ben je er klaar voor? <a href="/" onClick=\'javascript:window.location.reload();\'>Vernieuw je browser</a> om de nieuwste versie van WeTransfer te gebruiken.',
  user: {
    already_logged_in:
      'Je bent al ingelogd. Weet je zeker dat je je wachtwoord opnieuw wilt instellen?',
    roles: {
      admin: 'beheerder',
      owner: 'eigenaar',
      user: 'gebruiker',
    },
    sign_out_and_reset: 'Uitloggen en nieuw wachtwoord instellen',
  },
  click_here: 'Klik hier',
  cookiebox: {
    notice:
      '<bold>Je bent momenteel aangemeld</bold>, maar je wordt afgemeld als je je cookies hebt gewist. Dit heeft geen gevolgen voor oude transfers in je account.',
  },
  notice: {
    general_issues:
      'Werken de dingen niet zoals het hoort? Vervelend! Maar hou vol, wij lossen het <a target="_blank" href=%{link}>zo snel mogelijk op</a>',
    transfer_issues:
      'Zijn er problemen met je transfer? Vervelend! Maar hou vol, wij lossen het zo <a target="_blank" href=%{link}>snel mogelijk op</a>',
    verification:
      'Hoi, tijd om je <a href="/account"> e-mailadres te bevestigen</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Over | WeTransfer',
      advertise: 'Adverteer bij ons | WeTransfer',
      apps: 'Gratis apps voor Mac, iOS en Android | WeTransfer Apps',
      forgot_password: 'Wachtwoord resetten | WeTransfer Pro',
      help: 'Grote bestanden versturen? | WeTransfer Help',
      home: 'Eenvoudig grote bestanden delen - gratis! | WeTransfer',
      plus: 'Upgrade om grotere bestanden te kunnen versturen | WeTransfer Pro',
      sign_in: 'Aanmelden | WeTransfer Pro',
      sign_up: 'Aanmelden | WeTransfer Pro',
      upgrade: 'Upgrade | WeTransfer Pro',
      pricing:
        "Prijzen | WeTransfer - Verstuur grote bestanden en deel foto's online - tot 2 GB gratis",
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: 'Still haven’t found what you’re looking for?',
    },
  },
  splash: {
    footer: {
      or: 'of',
      send_files: 'Ik wil alleen mijn bestanden versturen',
      no_thanks: 'Nee, bedankt',
    },
    heading: {
      line_1_free:
        'WeTransfer is de beste manier om grote bestanden te versturen',
      line_2_free: 'Haal meer uit WeTransfer',
      free_account: 'Welkom terug. Wil je dit officieel maken?',
    },
    plan: {
      plus: {
        feature_10: 'Maak je e-mails persoonlijk',
        feature_11: 'Sla op tot %{plus_storage_limit}',
        feature_12: 'Bepaal wanneer transfers verlopen',
        feature_13: 'Beveilig je transfers met een wachtwoord',
        feature_7: 'Personaliseer je profiel',
        feature_8: 'Maak je eigen adresboek',
        feature_9: 'Maak je persoonlijke WeTransfer-URL',
      },
      free_account: {
        cta: 'Gratis aanmelden',
        feature_1: 'Geen opslag',
        feature_2: 'Verstuur tot %{free_transfer_limit}',
        feature_3: 'Transfers opnieuw versturen en verwijderen',
        heading: 'WeTransfer-account',
        price_label: 'Altijd gratis',
      },
      pro: {
        cta: 'Ga voor WeTransfer Pro',
        feature_1: '%{storage_limit_pro} aan opslag',
        feature_2: 'Verstuur en ontvang tot %{transfer_limit_pro}',
        feature_2_unlimited:
          'Verstuur en ontvang alle bestanden, hoe groot ze ook zijn',
        feature_3: 'Transfers opnieuw versturen en verwijderen',
        feature_4: 'Transfers beveiligen met een wachtwoord',
        feature_5: 'Je eigen Pro pagina en URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: '%{recipient} aan je team toevoegen?',
      text_content:
        'Teamleden hebben toegang tot elkaars transfers dankzij gedeelde opslag en branding. Je transfer wordt overigens niet geannuleerd.',
      cta: 'Meer lezen',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link gekopieerd',
      copy: 'Kopieer link',
      copy_again: 'Kopieer opnieuw',
    },
    labels: {
      share: 'Deel deze transfer',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PRO TIP',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Probeer portals uit',
        dismiss: 'Niet nu',
        text: "Je kunt klanten en collega's uitnodigen om je werk te bekijken en hun favorieten te selecteren met <strong>portals</strong>. Dat betekent een stuk minder heen-en-weer-gemail.",
        title: 'Heb je feedback nodig op je werk – en snel?',
      },
      'second-viewing': {
        cta: 'Probeer portals uit',
        dismiss: 'Laat dit niet meer zien',
        text: 'Krijg snelle feedback en deel nieuwe versies – allemaal op één plek. Met <strong>portals</strong> loods je jouw project soepel door feedbackrondes, aanpassingen en de uiteindelijke goedkeuring.',
        title: 'Je hebt je werk opgestuurd. En nu?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Ga naar Branding',
        text_2: "Wil je je eigen video's of afbeeldingen toevoegen?",
      },
      individual: {
        cta: 'Pagina instellen',
        text: "Maak elke keer als mensen je bestanden downloaden een geweldige indruk – voeg video's of afbeeldingen toe en kies je eigen url.",
        title: 'Laat je zien met je eigen WeTransfer-pagina',
      },
      invitee: {
        cta: "Ik snap 'm",
        text_1:
          'Met de eigen WeTransfer-pagina van je team maak je een geweldige indruk elke keer als je je werk deelt.',
        text_2:
          'Je kunt de achtergronden van je team op elk moment veranderen onder <strong>Branding</strong>.',
        title: "Zet je (team's) werk in de spotlight",
      },
      not_now: 'Niet nu',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Pagina instellen',
                  premium: {
                    text: 'Iedereen kan je transfers van elke grootte sturen via de eigen WeTransfer-pagina van je team.',
                  },
                  text: 'Iedereen kan je transfers tot %{transfer_limit_pro} sturen via de eigen WeTransfer-pagina van je team.',
                },
                premium: {
                  transfer_link: {
                    text: 'Iedereen kan je transfers van elke grootte sturen via %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Iedereen kan je transfers tot %{transfer_limit_pro} sturen via %{custom_link}',
                },
              },
              premium: {
                text: 'Iedereen kan je transfers van elke grootte sturen via de eigen WeTransfer-pagina van je team – je hoeft ze alleen deze link te geven.',
              },
              regular: {
                cta: "Ik snap 'm",
                text: 'Iedereen kan je transfers tot <strong>%{transfer_limit_pro}</strong> sturen via de WeTransfer-pagina van je team. Je hoeft ze alleen maar deze link te geven.',
                title: 'Eén plek voor alles wat je team ontvangt',
              },
            },
            sent: {
              regular: {
                cta: "Ik snap 'm",
                text: 'Dit is je gedeelde overzicht van de transfers die je team heeft verstuurd. Je kan hier downloads bijhouden, vervaldata aanpassen en zelfs transfers van anderen bewerken of verwijderen – al is het wel zo aardig om ze eerst even een seintje te geven!',
                title: 'Beheer de transfers van je team',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus is nu WeTransfer Pro met 1 TB opslagruimte — dat is 10x meer. <a href="/transfers">Bekijk nu.</a>',
  },
  refer_friend: {
    title: 'Aanbevelen',
    account: {
      description:
        'Jij en je vrienden ontvangen allemaal $ 10 wanneer ze zich aanmelden voor WeTransfer Pro of Premium. Deel je aanbevelingslink om een beloning te ontvangen in de vorm van een prepaid-creditcard, donatie aan een goed doel of cadeaubon van een van onze honderden partners.',
    },
    window: {
      link: 'Aanbevelingslink ophalen',
      send_another: 'Doorgaan',
      text: 'Jij en je vrienden ontvangen allemaal <strong>$ 10</strong> wanneer ze zich aanmelden voor WeTransfer Pro of Premium.',
      title: 'Beveel ons aan',
      title_2: 'voor het versturen van transfers.',
    },
    message: {
      success:
        'Je hebt er een vriend bij! Meld je aan voor WeTransfer Pro of Premium en ontvang allebei een prepaid-creditcard, donatie aan een goed doel of een cadeaubon ter waarde van $ 10.',
      self: 'Oh nee, die aanbevelingslink ziet er niet goed uit. Vraag je vriend om een nieuwe link en ontvang $ 10 wanneer je je aanmeldt voor WeTransfer Pro of Premium.',
      fallback:
        'Oh nee, die aanbevelingslink ziet er niet goed uit. Vraag je vriend om een nieuwe link en ontvang $ 10 wanneer je je aanmeldt voor WeTransfer Pro of Premium.',
      expired: 'Je aanbevelingslink is helaas verlopen.',
      dismiss: 'Negeren',
    },
  },
  order_summary: {
    coupon: {
      link: 'Actiecode toepassen',
      input_placeholder: 'Actiecode',
      button_label: 'Toepassen',
      error_message:
        'Sorry, met deze code krijg je alleen korting op een %{billing_period}-abonnement.',
      generic_error_message:
        'Sorry, deze code kan niet worden toegepast op dit abonnement',
      input_error_message: 'Hmm, dit is geen geldige code.',
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Totaal',
  },
  mobile_verify: {
    title: 'Klaar!',
    subtitle:
      'Je e-mailadres is geverifieerd. Je kunt de app nu gebruiken om transfers te versturen en te ontvangen.',
    cta: 'Open de WeTransfer-app',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Je huidige abonnement van <b>%{formattedintervaltotal}</b>/%{subscriptioninterval} wordt automatisch verlengd op <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Je huidige abonnement van <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) wordt automatisch verlengd op <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Je volgende betalingsdatum is <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> /%{interval}',
    team_upgrade_calculation: '(%{membercount} leden x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Geen limiet op bestandsgrootte voor transfers',
    premium_feature_two: 'Onbeperkte opslag',
    premium_feature_three: 'Onbeperkte portals en reviews',
    premium_feature_four:
      'Bekijk <a class="all-benefits-link" href="%{all_benefits_href}">alle voordelen</a>',
    premium_switch_cta_text: 'Stap over naar Premium',
    pill_text: 'Huidig abonnement',
    member_count: '%{membercount} leden',
    see_all_benefits: 'Bekijk alle abonnementsvoordelen',
    pending_downgrade_current_subscription:
      'Het abonnement op je werkruimte is geannuleerd en eindigt op <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Ben je van gedachten veranderd? Geen paniek, je kan heel gemakkelijk weer aan de slag.',
    pending_downgrade_reactivate_cta: 'Pro weer activeren',
    pending_downgrade_payment: 'Je hebt geen aankomende betalingen',
    update_payment_cta: 'Betaalgegevens bijwerken',
    cancel_plan:
      'Als je je abonnement opzegt, heb je toegang tot je %{planName}-werkruimte tot %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Je werkruimte wordt dan gedowngraded naar een gratis abonnement en je bestaande transfers verlopen na 28 dagen.',
    pending_payment_text:
      'To see your plan and payment information, please complete your payment or cancel your order.',
    learn_more: 'Learn more about plans and pricing',
  },
  time: {
    days: {
      monday: 'Maandag',
      tuesday: 'Dinsdag',
      wednesday: 'Woensdag',
      thursday: 'Donderdag',
      friday: 'Vrijdag',
      saturday: 'Zaterdag',
      sunday: 'Zondag',
    },
    months: {
      january: 'Januari',
      february: 'Februari',
      march: 'Maart',
      april: 'April',
      may: 'Mei',
      june: 'Juni',
      july: 'Juli',
      august: 'Augustus',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Nog minder dan 1 minuut',
        one: 'Nog ± 1 minuut',
        other: 'Nog ± %{count} minuten',
      },
      hours: {
        one: 'Nog ± 1 uur',
        other: 'Nog ± %{count} uren',
      },
    },
  },
  download: {
    shortcut: 'Druk op %{command} om de download voortgang te zien.',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Verstuur tot %{size}',
    progress: {
      busy: 'Versturen...',
    },
    buttons: {
      add: 'Voeg bestanden toe',
      transfer: 'Transfer',
      forward: 'Doorsturen',
      add_ios6: "Foto's en video's toevoegen",
      add_ios7: "Foto's toevoegen",
    },
    forward: {
      done: 'Doorsturen voltooid',
    },
    friend_email: {
      title: 'E-mail ontvanger(s)',
      more: 'Meer ontvangers toevoegen',
    },
    your_email: {
      title: 'Je e-mail',
    },
    message: {
      title: 'Bericht',
    },
    done: {
      title: 'Transfer afgerond',
      link: 'Kopieer je downloadlink:',
      copied: {
        title: 'Gekopieerd!',
        text: 'De downloadlink is gekopieerd.',
      },
    },
    more_html: 'Meer toevoegen<span>(%{size} over)</span>',
    too_many_recipients:
      'Het lijkt erop dat je teveel e-mailadressen hebt ingevoerd. Vergeet niet: er is ruimte voor maximaal %{count} mensen tegelijkertijd.',
    completed: '%{size} van %{total} voltooid',
    addresses: {
      one: '%{count} adres',
      other: '%{count} adressen',
      remove: 'Wil je %{address} verwijderen uit je vorige ontvangers?',
    },
    ads: {
      plus: {
        title: 'Haal meer uit WeTransfer<br />met Pro',
        text: "<ul><li>Grotere uploads</li><li>Gepersonaliseerde transfers met je eigen achtergronden</li><li>Beschermde transfers door wachtwoordprotectie</li><li>Lange termijn opslag</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Meer weten</a></p>",
      },
      plus2: {
        title: 'Maak indruk<br />met een eigen downloadpagina op maat',
        text: "<p>Gebruik je eigen achtergrondafbeeldingen en WeTransfer URL (jouwnaam.wetransfer.com) om indruk te maken op je ontvangers.</p><p><a target='_blank' href='/pro?trk=inapp'>Meer weten</a></p>",
      },
      plus3: {
        title: 'Beheer je<br />eigen Transfers slimmer',
        text: "<p>Deze transfer wordt na een week verwijderd, maar met WeTransfer Pro kun je je transfers bewaren zo lang als je wilt, ze direct doorsturen of verwijderen zonder dat je opnieuw hoeft te uploaden.</p><p><a target='_blank' href='/pro?trk=inapp'>Meer weten</a></p>",
      },
      plus4: {
        title: 'Extra bescherming van je bestanden',
        text: "<p>Met WeTransfer Pro kun je je belangrijke en vertrouwelijke bestanden beschermen met een wachtwoord. Op die manier vallen je bestanden nooit in verkeerde handen.</p><p><a target='_blank' href='/pro?trk=inapp'>Meer weten</a></p>",
      },
      facebook: {
        title: 'Ontdek de WeTransfer community op Facebook',
        text: "<p>Ontvang het laatste nieuws, win prijzen, ontdek nieuwe artiesten, lees interviews en nog veel meer.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Ontdek meer</a>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        'Sorry, alleen e-mail wordt ondersteund bij het opnieuw versturen van een transfer.',
      connect_twitter:
        'Je Twitter account is nog niet gekoppeld aan WeTransfer.',
      connect_facebook:
        'Je Facebook account is nog niet gekoppeld aan WeTransfer.',
      transferproblems: {
        title: 'Transfer probleem',
        text: 'Sorry, maar er is iets fout gegaan met de transfer.',
      },
      limitreached: {
        title: 'Opslaglimiet',
        text: 'Je hebt je limiet van 1 TB bereikt. Verwijder oude transfers om nieuwe bestanden te kunnen verzenden.',
      },
      blocked: {
        title: 'Transfer probleem',
        text: 'Computer zegt nee. Sorry, maar je bent geblokkeerd van WeTransfer.',
      },
      upload_error: {
        title: 'Transfer probleem',
        text: 'Sorry, maar er is iets fout gegaan met de transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, deze transfer is al verwijderd en kan dus niet worden doorgestuurd.',
      },
      startswithdot: {
        title: 'Oeps',
        text: 'Een (of meer) van je bestanden heeft een naam die begint met een punt. Dat gaat niet werken. Pas de naam van het/de bestand(en) aan en probeer ze opnieuw toe te voegen.',
      },
      startswithspace: {
        title: 'Oeps',
        text: 'Een (of meer) van je bestanden heeft een naam die begint met een spatie. Dat gaat niet werken. Pas de naam van het/de bestand(en) aan en probeer ze opnieuw toe te voegen.',
      },
      containsreturn: {
        title: 'Oeps',
        text: 'Een (of meer) van je bestanden heeft een naam die een enter bevat. We weten niet goed hoe je dat gedaan hebt, maar dit gaat niet werken. Pas de naam van het/de bestand(en) aan en probeer ze opnieuw toe te voegen.',
      },
      alreadyinlist: {
        title: 'Oeps',
        text: 'Het blijkt dat een van je bestanden dezelfde naam had als een ander bestand dat je al hebt geselecteerd. Pas het iets aan!',
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: 'Het spijt ons heel erg, maar we kunnen niet meer dan %{upload_limit}GB per keer verzenden.',
      },
      filetoobig: {
        title: 'Uh-oh',
        text: 'Het spijt ons heel erg, maar we kunnen niet meer dan %{upload_limit}GB per keer verzenden.',
      },
      zerobytes: {
        title: 'Oeps',
        text: 'Een (of meer) van je bestanden is leeg of kon niet worden gelezen.',
      },
      ioerror: {
        title: 'Mislukt',
        text: 'Een (of meer) van je bestanden kon niet worden gelezen of is groter dan %{upload_limit}GB. Dat gaat hem niet worden.',
      },
      filenametoolong: {
        title: 'Oeps',
        text: 'Een (of meer) van je bestanden heeft een bestandsnaam die langer is dan 250 tekens. We kunnen bestandsnamen langer dan dit niet accepteren, pas daarom de naam aan.',
      },
      nofolders: {
        title: 'Uh-oh',
        text: 'Sorry, het uploaden van mappen is nog niet mogelijk. Probeer het eerst in te pakken.',
      },
      nofiles: {
        title: 'Oeps',
        text: 'Je hebt nog geen bestanden toegevoegd.',
      },
      norecipients: {
        title: 'Doh!',
        text: 'Het lijkt erop dat je vergeten bent om e-mailadressen in te voeren om naar te versturen.',
      },
      toomanyrecipients: {
        title: 'Oeps',
        text: 'Te veel ontvangers.',
      },
      bigmessage: {
        title: 'Oeps',
        text: 'Je bericht is langer dan een roman. Kort je tekst in aub.',
      },
      nosender: {
        title: 'Meen je dat nou?',
        text: 'Je bent vergeten om je eigen e-mailadres in te voeren. Hoe kon je dit nou doen?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Je e-mailadres lijkt niet juist zijn. Let op je spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: 'Het lijkt alsof je de link niet hebt gekopieerd.',
      },
      recipientemailinvalidformat: {
        title: 'Oeps',
        text: 'Je hebt een van de e-mailadressen van je ontvangers verkeerd ingevoerd.',
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Oeps',
        text: 'Een (of meer) van je bestanden heeft een bestandsnaam die een backslash bevat. We kunnen dit niet accepteren. Pas de naam van de bestanden aan zodat ze de backslash niet bevatten.',
      },
      title: 'Oeps',
      text: "Met iOS7 kun je geen bestanden via onze website versturen, maar met onze <a href='%{wetransfer_ios_app_store_url}'>fantastishce WeTransfer app</a> kan het wel!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: 'Je kunt tot 2 GB per transfer versturen. En wat nog mooier is: je kunt zo vaak versturen als je wilt.',
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Belangrijk',
        text: 'Jouw Pro-account kan tot 20 GB per transfer versturen, maar je browser houdt dit tegen. <a href="/questions/33">Klik hier voor meer informatie.</a>',
      },
      recipients_tip: {
        title: 'Tip',
        text: 'Je kunt maximaal %{email_limit} e-mailadressen invoeren om naar te versturen. Als je gewoon een download-link wilt, klikt op de deelknop hierbeneden.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Voer je eigen e-mailadres hier in, zodat we contact met je kunnen opnemen wanneer de bestanden zijn gedownload.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'Je kunt nu de vervaldatum van je Pro transfers wijzigen.',
      },
      message_tip: {
        title: 'Tip',
        text: 'Wil je een bericht aan je transfer toevoegen? Dit is je kans - het is niet verplicht.',
      },
      share_tip: {
        title: 'Tip',
        text: 'Verander de manier waarop je je bestanden deelt. Stuur ze via e-mail of maak een downloadlink aan.',
        text_plus:
          'Verander de manier waarop je je bestanden deelt. Stuur ze via e-mail, Twitter, Facebook, of maak een downloadlink aan.',
      },
      download: {
        title: '',
        chrome:
          "Downloaden werkt anders dan voorheen. We downloaden nu alle bestanden via de browser, dus je zult niet langer de vooruitgang zien in WeTransfer. Ook kan het voorkomen dat je niet wordt gevraagd waar je het bestand wilt opslaan. De voortgang van het downloaden zou zichtbaar moeten zijn aan de onderkant van je browservenster. Je bestand wordt standaard opgeslagen in je Downloads map. <a href='/questions/24' target='_blank'>Lees hier hoe je dit kunt aanpassen.</a>.",
        firefox:
          "Downloaden werkt anders dan voorheen. We downloaden nu alle alle bestanden via de browser, dus je zult niet langer de vooruitgang zien in WeTransfer. Ook kan het voorkomen dat je niet wordt gevraagd waar je het bestand wilt opslaan. De voortgang zou zichtbaar moeten zijn in het downloadvenster van je browser. Je bestand wordt standaard opgeslagen in je Downloads map. <a href='/questions/24' target='_blank'>Lees hier hoe je dit kunt aanpassen</a>.",
        safari:
          "Downloaden werkt anders dan voorheen. We downloaden nu alle bestanden via de browser, dus je zult niet langer de vooruitgang zien in WeTransfer. Ook kan het voorkomen dat je niet wordt gevraagd waar je het bestand wilt opslaan. De voortgang zou zichtbaar moeten zijn in de rechter bovenhoek van je browservenster. Je bestand wordt standaard opgeslagen in je Downloads map. <a href='/questions/24' target='_blank'>Lees hier hoe je dit kunt aanpassen</a>.",
        old_explorer:
          "Downloaden werkt anders dan voorheen. We downloaden nu alle bestanden via de browser, dus je zult niet langer de vooruitgang zien in WeTransfer. Ook kan het voorkomen dat je niet wordt gevraagd waar je het bestand wilt opslaan. Je zult wellicht ook een beveiligingswaarschuwing zien aan de bovenkant van het browservenster. <a href='/questions/24' target='_blank'>Meer informatie?</a>",
        explorer:
          "Downloaden werkt anders dan voorheen. We downloaden nu alle bestanden via de browser, dus je zult niet langer de vooruitgang zien in WeTransfer. Ook kan het voorkomen dat je niet wordt gevraagd waar je het bestand wilt opslaan. De voortgang zou zichtbaar moeten zijn aan de onderkant van je browservenster (je zult misschien eerst op 'opslaan' moeten klikken). Je bestand wordt standaard opgeslagen in je Downloads map. <a href='/questions/24' target='_blank'>Meer informatie?</a>",
        settings:
          'Je kunt je standaard downloadlocatie in je browserinstellingen aanpassen.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Het doorsturen van deze transfer zal het formulier wissen. Weet je het zeker?',
    is_busy: 'Sorry, dit kunnen wij nu niet doen.',
  },
  mobile_app: {
    remember_choice: 'Deze melding niet meer tonen',
    uploader: {
      description:
        'Onze site is momenteel niet voor mobiel geoptimaliseerd. Maar we hebben wel een fantastische mobiele app.',
      app_name: 'WeTransfer',
      download: 'Download de app',
      continue: 'Ga verder naar WeTransfer.com',
    },
    downloader: {
      title: 'Uw bestanden zijn gereed voor downloaden',
      description_ios:
        'Wij hebben uw bestanden gebundeld in een zip-bestand. U heeft een app nodig om de bestanden uit te pakken en te bekijken. Volgens onze bescheiden mening is <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a> een prima app voor dat doel.',
      description_android:
        'Wij hebben uw bestanden gebundeld in een zip-bestand. U heeft een app nodig om de bestanden uit te pakken en te bekijken. Volgens onze bescheiden mening is <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a> een prima app voor dat doel.',
      continue: 'Ik snap het',
    },
  },
};
